import L from "leaflet";

import "leaflet-velocity/dist/leaflet-velocity.css";

const STATE_KEY = "hydrotools:realtime-weather:v3";

const GLOBAL_PRESETS = [
  {
    id: "ioos-hfr-currents",
    name: "IOOS HFR Surface Currents (Hawaii 1km)",
    url: "https://pae-paha.pacioos.hawaii.edu/thredds/wms/hfradar_ushi_1km",
    layer: "u:v-mag",
    source: "ioos-pacioos-hfr",
    cadenceHours: 1,
    historyHours: 24,
    futureHours: 12,
  },
  {
    id: "ioos-roms-currents",
    name: "IOOS ROMS Surface Currents (Oahu)",
    url: "https://pae-paha.pacioos.hawaii.edu/thredds/wms/roms_hiog/ROMS_Oahu_Regional_Ocean_Model_best.ncd",
    layer: "u:v-mag",
    source: "ioos-pacioos-roms",
    cadenceHours: 1,
    historyHours: 24,
    futureHours: 72,
  },
  {
    id: "ioos-roms-water-level",
    name: "IOOS ROMS Water Level (Oahu)",
    url: "https://pae-paha.pacioos.hawaii.edu/thredds/wms/roms_hiog/ROMS_Oahu_Regional_Ocean_Model_best.ncd",
    layer: "zeta",
    source: "ioos-pacioos-roms",
    cadenceHours: 1,
    historyHours: 24,
    futureHours: 72,
  },
  {
    id: "ioos-swan-wave-height",
    name: "IOOS SWAN Wave Height (Oahu)",
    url: "https://pae-paha.pacioos.hawaii.edu/thredds/wms/swan_oahu/SWAN_Oahu_Regional_Wave_Model_best.ncd",
    layer: "shgt",
    source: "ioos-pacioos-swan",
    cadenceHours: 1,
    historyHours: 24,
    futureHours: 72,
  },
  {
    id: "ioos-wrf-wind",
    name: "IOOS WRF Wind Speed (Hawaii)",
    url: "https://pae-paha.pacioos.hawaii.edu/thredds/wms/wrf_hi/WRF_Hawaii_Regional_Atmospheric_Model_best.ncd",
    layer: "wind",
    source: "ioos-pacioos-wrf",
    cadenceHours: 1,
    historyHours: 24,
    futureHours: 72,
  },
  {
    id: "gfs-wind",
    name: "Global Wind (GFS)",
    url: "https://thredds.ucar.edu/thredds/wms/grib/NCEP/GFS/Global_0p25deg/Best",
    layer: "u-component_of_wind_height_above_ground:v-component_of_wind_height_above_ground-mag",
    source: "ucar-thredds-gfs",
    cadenceHours: 3,
    historyHours: 24,
    futureHours: 240,
    vector: {
      type: "ucar-gfs-wind",
      opendapUrl: "/api/realtime-weather/ucar-gfs",
      uVar: "u-component_of_wind_height_above_ground",
      vVar: "v-component_of_wind_height_above_ground",
      levelVar: "height_above_ground2",
      levelValue: 10,
      timeVar: "time",
      latVar: "lat",
      lonVar: "lon",
    },
    sample: {
      type: "ucar-gfs-vector-point",
      opendapUrl: "/api/realtime-weather/ucar-gfs",
      uVar: "u-component_of_wind_height_above_ground",
      vVar: "v-component_of_wind_height_above_ground",
      levelVar: "height_above_ground2",
      levelValue: 10,
      timeVar: "time",
      latVar: "lat",
      lonVar: "lon",
      label: "Wind",
      speedUnit: "m/s",
    },
  },
  {
    id: "gfs-temp",
    name: "Global Temperature (GFS)",
    url: "https://thredds.ucar.edu/thredds/wms/grib/NCEP/GFS/Global_0p25deg/Best",
    layer: "Temperature_surface",
    source: "ucar-thredds-gfs",
    cadenceHours: 3,
    historyHours: 24,
    futureHours: 240,
    sample: {
      type: "ucar-gfs-scalar-point",
      opendapUrl: "/api/realtime-weather/ucar-gfs",
      scalarVar: "Temperature_surface",
      timeVar: "time",
      latVar: "lat",
      lonVar: "lon",
      label: "Temperature",
      unit: "K",
    },
  },
  {
    id: "gfs-pressure",
    name: "Global Pressure (GFS)",
    url: "https://thredds.ucar.edu/thredds/wms/grib/NCEP/GFS/Global_0p25deg/Best",
    layer: "MSLP_Eta_model_reduction_msl",
    source: "ucar-thredds-gfs",
    cadenceHours: 3,
    historyHours: 24,
    futureHours: 240,
    sample: {
      type: "ucar-gfs-scalar-point",
      opendapUrl: "/api/realtime-weather/ucar-gfs",
      scalarVar: "MSLP_Eta_model_reduction_msl",
      timeVar: "time",
      latVar: "lat",
      lonVar: "lon",
      label: "Pressure",
      unit: "Pa",
    },
  },
  {
    id: "gfs-humidity",
    name: "Global Relative Humidity (GFS)",
    url: "https://thredds.ucar.edu/thredds/wms/grib/NCEP/GFS/Global_0p25deg/Best",
    layer: "Relative_humidity_height_above_ground",
    source: "ucar-thredds-gfs",
    cadenceHours: 3,
    historyHours: 24,
    futureHours: 240,
    sample: {
      type: "ucar-gfs-scalar-point",
      opendapUrl: "/api/realtime-weather/ucar-gfs",
      scalarVar: "Relative_humidity_height_above_ground",
      timeVar: "time",
      latVar: "lat",
      lonVar: "lon",
      levelVar: "height_above_ground4",
      levelValue: 2,
      label: "Relative Humidity",
      unit: "%",
    },
  },
  {
    id: "gfs-cloud",
    name: "Global Cloud Cover (GFS)",
    url: "https://thredds.ucar.edu/thredds/wms/grib/NCEP/GFS/Global_0p25deg/Best",
    layer: "Total_cloud_cover_entire_atmosphere",
    source: "ucar-thredds-gfs",
    cadenceHours: 3,
    historyHours: 24,
    futureHours: 240,
    sample: {
      type: "ucar-gfs-scalar-point",
      opendapUrl: "/api/realtime-weather/ucar-gfs",
      scalarVar: "Total_cloud_cover_entire_atmosphere",
      timeVar: "time",
      latVar: "lat",
      lonVar: "lon",
      label: "Cloud Cover",
      unit: "%",
    },
  },
  {
    id: "gfs-precip",
    name: "Global Precipitation Rate (GFS)",
    url: "https://thredds.ucar.edu/thredds/wms/grib/NCEP/GFS/Global_0p25deg/Best",
    layer: "Precipitation_rate_surface",
    source: "ucar-thredds-gfs",
    cadenceHours: 3,
    historyHours: 24,
    futureHours: 240,
    sample: {
      type: "ucar-gfs-scalar-point",
      opendapUrl: "/api/realtime-weather/ucar-gfs",
      scalarVar: "Precipitation_rate_surface",
      timeVar: "time",
      latVar: "lat",
      lonVar: "lon",
      label: "Precipitation Rate",
      unit: "kg/m2/s",
    },
  },
  {
    id: "gfs-gust",
    name: "Global Wind Gusts (GFS)",
    url: "https://thredds.ucar.edu/thredds/wms/grib/NCEP/GFS/Global_0p25deg/Best",
    layer: "Wind_speed_gust_surface",
    source: "ucar-thredds-gfs",
    cadenceHours: 3,
    historyHours: 24,
    futureHours: 240,
    sample: {
      type: "ucar-gfs-scalar-point",
      opendapUrl: "/api/realtime-weather/ucar-gfs",
      scalarVar: "Wind_speed_gust_surface",
      timeVar: "time",
      latVar: "lat",
      lonVar: "lon",
      label: "Wind Gust",
      unit: "m/s",
    },
  },
  {
    id: "ww3-wave",
    name: "Global Wave Height (WW3)",
    url: "https://thredds.ucar.edu/thredds/wms/grib/NCEP/WW3/Global/Best",
    layer: "Significant_height_of_combined_wind_waves_and_swell_surface",
    source: "ucar-thredds-ww3",
    cadenceHours: 3,
    historyHours: 24,
    futureHours: 180,
  },
  {
    id: "ncom-current",
    name: "Global Surface Currents (NCOM)",
    url: "https://www.ncei.noaa.gov/thredds-coastal/wms/ncom/ncom_sfc8_agg/NCOM_SFC_8_Aggregation_best.ncd",
    layer: "water_u:water_v-mag",
    source: "ncei-thredds-ncom",
    cadenceHours: 3,
    historyHours: 24,
    futureHours: 72,
  },
];

function esc(v) {
  return String(v ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll("\"", "&quot;");
}

function readState() {
  const systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  try {
    const raw = localStorage.getItem(STATE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return {
      presetId: typeof parsed.presetId === "string" ? parsed.presetId : GLOBAL_PRESETS[0].id,
      opacity: Number.isFinite(Number(parsed.opacity)) ? Math.max(0, Math.min(1, Number(parsed.opacity))) : 0.75,
      layerVisible: parsed.layerVisible !== false,
      timeMode: parsed.timeMode === "specific" ? "specific" : "latest",
      timeLocal: typeof parsed.timeLocal === "string" ? parsed.timeLocal : "",
      playbackMs: Number.isFinite(Number(parsed.playbackMs)) ? Math.max(200, Math.min(4000, Number(parsed.playbackMs))) : 800,
      playbackRate: [1, 2, 3].includes(Number(parsed.playbackRate)) ? Number(parsed.playbackRate) : 1,
      pickerEnabled: parsed.pickerEnabled === true,
      timeZone: typeof parsed.timeZone === "string" && parsed.timeZone.trim() ? parsed.timeZone : systemTimeZone,
    };
  } catch {
    return {
      presetId: GLOBAL_PRESETS[0].id,
      opacity: 0.75,
      layerVisible: true,
      timeMode: "latest",
      timeLocal: "",
      playbackMs: 800,
      playbackRate: 1,
      pickerEnabled: false,
      timeZone: systemTimeZone,
    };
  }
}

function saveState(state) {
  try { localStorage.setItem(STATE_KEY, JSON.stringify(state)); } catch {}
}

function parseIsoDurationMs(duration) {
  const s = String(duration || "").trim();
  const m = /^P(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?$/i.exec(s);
  if (!m) return null;
  const days = Number(m[1] || 0);
  const hours = Number(m[2] || 0);
  const mins = Number(m[3] || 0);
  const secs = Number(m[4] || 0);
  const ms = (((days * 24 + hours) * 60 + mins) * 60 + secs) * 1000;
  return ms > 0 ? ms : null;
}

function parseTimeExtent(raw) {
  const text = String(raw || "").trim();
  if (!text) return [];
  if (text.includes(",")) return text.split(",").map((x) => x.trim()).filter(Boolean);
  const parts = text.split("/");
  if (parts.length === 3) {
    const start = new Date(parts[0]);
    const end = new Date(parts[1]);
    const stepMs = parseIsoDurationMs(parts[2]) ?? (60 * 60 * 1000);
    if (!Number.isFinite(start.getTime()) || !Number.isFinite(end.getTime()) || stepMs <= 0) return [];
    const out = [];
    let t = start.getTime();
    const max = 1000;
    while (t <= end.getTime() && out.length < max) {
      out.push(new Date(t).toISOString());
      t += stepMs;
    }
    if (out.length === 0 || out[out.length - 1] !== end.toISOString()) out.push(end.toISOString());
    return out;
  }
  const d = new Date(text);
  if (Number.isFinite(d.getTime())) return [d.toISOString()];
  return [];
}

function parseLayerTimesFromCapabilities(xmlText, targetLayerName) {
  const doc = new DOMParser().parseFromString(xmlText, "application/xml");
  if (doc.querySelector("parsererror")) throw new Error("WMS capabilities parse error");
  const layers = Array.from(doc.getElementsByTagName("Layer"));
  const candidates = [
    String(targetLayerName || "").trim(),
    String(targetLayerName || "").split(":")[0].trim(),
  ].filter(Boolean);
  for (const candidate of candidates) {
    for (const layerEl of layers) {
      const nameEl = Array.from(layerEl.children || []).find((c) => (c.localName || c.nodeName) === "Name");
      const name = String(nameEl?.textContent || "").trim();
      if (!name || name !== candidate) continue;

      for (const dim of Array.from(layerEl.children || [])) {
        const local = dim.localName || dim.nodeName;
        if (local !== "Dimension" && local !== "Extent") continue;
        const dimName = String(dim.getAttribute?.("name") || "").toLowerCase();
        if (dimName !== "time") continue;
        return parseTimeExtent(String(dim.textContent || ""));
      }
      return [];
    }
  }
  return [];
}

function toWmsTime(localInput) {
  const trimmed = String(localInput || "").trim();
  if (!trimmed) return null;
  const dt = new Date(trimmed);
  if (!Number.isFinite(dt.getTime())) return null;
  return dt.toISOString();
}

function fmtIso(v) {
  const d = new Date(String(v || ""));
  return Number.isFinite(d.getTime()) ? d.toISOString().replace(".000Z", "Z") : String(v || "");
}

function toLocalInputValue(ms) {
  const d = new Date(ms);
  if (!Number.isFinite(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${y}-${m}-${day}T${hh}:${mm}`;
}

function formatForecastReadout(iso, speedKt, timeZone = "UTC") {
  const d = new Date(String(iso || ""));
  if (!Number.isFinite(d.getTime())) return `${String(iso || "")} · ${Number(speedKt).toFixed(1)} kt`;
  const label = new Intl.DateTimeFormat("en-US", {
    timeZone,
    weekday: "short",
    month: "short",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZoneName: "short",
  }).format(d);
  return `${label} · ${Number(speedKt).toFixed(1)} kt`;
}

function generateFallbackTimes(preset) {
  const cadenceHours = Math.max(1, Number(preset?.cadenceHours) || 3);
  const historyHours = Math.max(0, Number(preset?.historyHours) || 24);
  const futureHours = Math.max(0, Number(preset?.futureHours) || 72);
  const stepMs = cadenceHours * 3600 * 1000;
  const now = Date.now();
  const start = now - (historyHours * 3600 * 1000);
  const end = now + (futureHours * 3600 * 1000);
  const aligned = Math.floor(start / stepMs) * stepMs;
  const out = [];
  for (let t = aligned; t <= end; t += stepMs) out.push(new Date(t).toISOString());
  return out;
}

let velocityPluginPromise = null;
const VECTOR_META_CACHE = new Map();
const POINT_META_CACHE = new Map();

async function ensureVelocityPluginLoaded() {
  if (typeof L.velocityLayer === "function") return;
  if (!velocityPluginPromise) {
    globalThis.L = globalThis.L || L;
    velocityPluginPromise = import("leaflet-velocity");
  }
  await velocityPluginPromise;
}

function escapeRegExp(value) {
  return String(value || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function extractSimpleAsciiArray(text, name) {
  const rx = new RegExp(`(?:^|\\n)${escapeRegExp(name)}\\[[^\\n]*\\]\\n([^\\n]+)`, "m");
  const match = rx.exec(String(text || ""));
  if (!match) return [];
  return String(match[1] || "")
    .split(",")
    .map((part) => Number.parseFloat(String(part).trim()))
    .filter((num) => Number.isFinite(num));
}

function extractGridAscii(text, varName) {
  const lines = String(text || "").split(/\r?\n/);
  const arrayPrefix = `${varName}.${varName}[`;
  const timePrefix = `${varName}.time[`;
  const latPrefix = `${varName}.lat[`;
  const lonPrefix = `${varName}.lon[`;
  const data = [];
  let time = null;
  let lat = [];
  let lon = [];

  for (let i = 0; i < lines.length; i += 1) {
    const line = lines[i];
    if (line.startsWith(arrayPrefix)) {
      let cursor = i + 1;
      while (cursor < lines.length && lines[cursor].startsWith("[")) {
        const row = lines[cursor]
          .split(",")
          .slice(1)
          .map((part) => Number.parseFloat(String(part).trim()));
        data.push(...row);
        cursor += 1;
      }
      i = cursor - 1;
      continue;
    }
    if (line.startsWith(timePrefix)) {
      const vals = String(lines[i + 1] || "")
        .split(",")
        .map((part) => Number.parseFloat(String(part).trim()))
        .filter((num) => Number.isFinite(num));
      time = vals[0] ?? null;
      i += 1;
      continue;
    }
    if (line.startsWith(latPrefix)) {
      lat = String(lines[i + 1] || "")
        .split(",")
        .map((part) => Number.parseFloat(String(part).trim()))
        .filter((num) => Number.isFinite(num));
      i += 1;
      continue;
    }
    if (line.startsWith(lonPrefix)) {
      lon = String(lines[i + 1] || "")
        .split(",")
        .map((part) => Number.parseFloat(String(part).trim()))
        .filter((num) => Number.isFinite(num));
      i += 1;
    }
  }

  if (!data.length || !lat.length || !lon.length) {
    throw new Error(`No grid data returned for ${varName}`);
  }

  return { data, time, lat, lon };
}

function extractSingleGridValue(text, varName) {
  const lines = String(text || "").split(/\r?\n/);
  const arrayPrefix = `${varName}.${varName}[`;
  for (let i = 0; i < lines.length; i += 1) {
    if (!lines[i].startsWith(arrayPrefix)) continue;
    const valueLine = String(lines[i + 1] || "").trim();
    if (!valueLine.startsWith("[")) break;
    const parts = valueLine.split(",").slice(1);
    const value = Number.parseFloat(String(parts[0] || "").trim());
    if (Number.isFinite(value)) return value;
    break;
  }
  throw new Error(`No point value returned for ${varName}`);
}

function extractSeriesGridValues(text, varName) {
  const lines = String(text || "").split(/\r?\n/);
  const arrayPrefix = `${varName}.${varName}[`;
  const values = [];
  let inArray = false;
  for (const line of lines) {
    if (line.startsWith(arrayPrefix)) {
      inArray = true;
      continue;
    }
    if (!inArray) continue;
    if (!line.startsWith("[")) break;
    const value = Number.parseFloat(String(line.split(",").slice(1)[0] || "").trim());
    values.push(Number.isFinite(value) ? value : null);
  }
  if (!values.length) throw new Error(`No point series returned for ${varName}`);
  return values;
}

function parseDasTimeBase(dasText, axisName) {
  const rx = new RegExp(`${escapeRegExp(axisName)}\\s*\\{[\\s\\S]*?String units \"Hour since ([^\"]+)\";`, "m");
  const match = rx.exec(String(dasText || ""));
  const iso = match?.[1] ? new Date(match[1]).toISOString() : null;
  if (!iso) throw new Error("Could not parse forecast time base");
  return iso;
}

function normalizeLon360(value) {
  const lon = Number(value);
  if (!Number.isFinite(lon)) return null;
  return ((lon % 360) + 360) % 360;
}

function nearestValueIndex(values, target) {
  if (!Array.isArray(values) || !values.length) return 0;
  let bestIndex = 0;
  let bestDist = Number.POSITIVE_INFINITY;
  values.forEach((value, index) => {
    const dist = Math.abs(Number(value) - Number(target));
    if (dist < bestDist) {
      bestDist = dist;
      bestIndex = index;
    }
  });
  return bestIndex;
}

function nearestTimeMetaIndex(times, targetIso) {
  const targetMs = new Date(String(targetIso || "")).getTime();
  if (!Number.isFinite(targetMs)) return Math.max(0, times.length - 1);
  let bestIndex = 0;
  let bestDist = Number.POSITIVE_INFINITY;
  times.forEach((iso, index) => {
    const ms = new Date(String(iso || "")).getTime();
    if (!Number.isFinite(ms)) return;
    const dist = Math.abs(ms - targetMs);
    if (dist < bestDist) {
      bestDist = dist;
      bestIndex = index;
    }
  });
  return bestIndex;
}

function findAscendingRange(values, min, max) {
  let start = 0;
  while (start < values.length - 1 && values[start] < min) start += 1;
  let end = values.length - 1;
  while (end > 0 && values[end] > max) end -= 1;
  return [Math.max(0, start - 1), Math.min(values.length - 1, end + 1)];
}

function findDescendingRange(values, min, max) {
  let start = 0;
  while (start < values.length - 1 && values[start] > max) start += 1;
  let end = values.length - 1;
  while (end > 0 && values[end] < min) end -= 1;
  return [Math.max(0, start - 1), Math.min(values.length - 1, end + 1)];
}

function estimateStride(latCount, lonCount, maxCells = 24000) {
  const total = Math.max(1, Number(latCount) || 1) * Math.max(1, Number(lonCount) || 1);
  if (total <= maxCells) return 1;
  return Math.max(1, Math.ceil(Math.sqrt(total / maxCells)));
}

function buildVelocityRecord(data, lat, lon, refTime, forecastHour, parameterNumber) {
  const latStep = lat.length > 1 ? Math.abs(Number(lat[1]) - Number(lat[0])) : 0.25;
  const lonStep = lon.length > 1 ? Math.abs(Number(lon[1]) - Number(lon[0])) : 0.25;
  return {
    header: {
      parameterCategory: 2,
      parameterNumber,
      lo1: Number(lon[0]),
      la1: Number(lat[0]),
      dx: lonStep,
      dy: latStep,
      nx: lon.length,
      ny: lat.length,
      refTime,
      forecastTime: Number(forecastHour) || 0,
    },
    data,
  };
}

function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function getWindParticleOptions(map) {
  const zoom = Number(map?.getZoom?.() || 0);
  const bounds = map?.getBounds?.();
  const latSpan = Math.abs(Number(bounds?.getNorth?.() || 0) - Number(bounds?.getSouth?.() || 0));
  const lonSpan = Math.abs(Number(bounds?.getEast?.() || 0) - Number(bounds?.getWest?.() || 0));
  const span = Math.max(latSpan, lonSpan, 0.1);

  const zoomFactor = clamp((zoom - 3) / 9, 0, 1);
  const spanFactor = clamp((25 - span) / 25, 0, 1);
  const localFactor = clamp(Math.max(zoomFactor, spanFactor), 0, 1);

  return {
    velocityScale: 0.008 - (localFactor * 0.0035),
    particleMultiplier: 1 / Math.round(165 + (localFactor * 700)),
    particleAge: Math.round(94 - (localFactor * 38)),
    frameRate: Math.round(20 - (localFactor * 4)),
    lineWidth: 1.55 - (localFactor * 0.22),
    minVelocity: 0,
    maxVelocity: 25,
  };
}

function getWindParticleOpacity(baseOpacity) {
  return Math.max(0.84, Math.min(1, Number(baseOpacity) * 1.22));
}

function getWindColorOverlayOpacity(baseOpacity) {
  return Math.max(0.08, Math.min(0.28, Number(baseOpacity) * 0.32));
}

function denormalizeLon(value) {
  const lon = Number(value);
  if (!Number.isFinite(lon)) return lon;
  return lon > 180 ? lon - 360 : lon;
}

function getWindFieldColor(speed) {
  const stops = [
    [0, [38, 70, 134]],
    [3, [41, 120, 181]],
    [6, [46, 174, 196]],
    [10, [103, 206, 146]],
    [14, [184, 224, 94]],
    [18, [246, 220, 79]],
    [22, [241, 161, 68]],
    [28, [225, 104, 50]],
    [35, [192, 57, 43]],
    [45, [122, 33, 91]],
  ];
  if (!Number.isFinite(speed)) return [0, 0, 0, 0];
  if (speed <= stops[0][0]) return [...stops[0][1], 255];
  for (let i = 1; i < stops.length; i += 1) {
    const [nextValue, nextColor] = stops[i];
    const [prevValue, prevColor] = stops[i - 1];
    if (speed <= nextValue) {
      const t = (speed - prevValue) / Math.max(1e-6, nextValue - prevValue);
      return [
        Math.round(prevColor[0] + ((nextColor[0] - prevColor[0]) * t)),
        Math.round(prevColor[1] + ((nextColor[1] - prevColor[1]) * t)),
        Math.round(prevColor[2] + ((nextColor[2] - prevColor[2]) * t)),
        255,
      ];
    }
  }
  return [...stops[stops.length - 1][1], 255];
}

function interpolateWindMagnitude(grid, lon, lat) {
  const lon0 = Number(grid?.lon?.[0]);
  const lon1 = Number(grid?.lon?.[1] ?? lon0 + 0.25);
  const lat0 = Number(grid?.lat?.[0]);
  const lat1 = Number(grid?.lat?.[1] ?? lat0 - 0.25);
  const dx = Math.abs(lon1 - lon0) || 0.25;
  const dy = Math.abs(lat1 - lat0) || 0.25;
  const nx = Number(grid?.nx || 0);
  const ny = Number(grid?.ny || 0);
  if (!nx || !ny) return null;

  const x = (lon - lon0) / dx;
  const y = (lat0 - lat) / dy;
  const i = Math.floor(x);
  const j = Math.floor(y);
  if (i < 0 || j < 0 || i >= nx - 1 || j >= ny - 1) return null;
  const tx = x - i;
  const ty = y - j;
  const idx = (row, col) => (row * nx) + col;
  const m00 = Number(grid.magnitude[idx(j, i)]);
  const m10 = Number(grid.magnitude[idx(j, i + 1)]);
  const m01 = Number(grid.magnitude[idx(j + 1, i)]);
  const m11 = Number(grid.magnitude[idx(j + 1, i + 1)]);
  if (![m00, m10, m01, m11].every(Number.isFinite)) return null;
  const top = m00 + ((m10 - m00) * tx);
  const bottom = m01 + ((m11 - m01) * tx);
  return top + ((bottom - top) * ty);
}

function renderWindFieldOverlay(grid) {
  const west = Number(grid.lon[0]);
  const east = Number(grid.lon[grid.lon.length - 1]);
  const north = Number(grid.lat[0]);
  const south = Number(grid.lat[grid.lat.length - 1]);
  const lonSpan = Math.max(0.01, east - west);
  const latSpan = Math.max(0.01, north - south);
  const baseWidth = 768;
  const width = clamp(Math.round(baseWidth), 320, 960);
  const height = clamp(Math.round(baseWidth * (latSpan / lonSpan)), 220, 900);
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  const image = ctx.createImageData(width, height);

  for (let py = 0; py < height; py += 1) {
    const lat = north - ((py / Math.max(1, height - 1)) * latSpan);
    for (let px = 0; px < width; px += 1) {
      const lon = west + ((px / Math.max(1, width - 1)) * lonSpan);
      const mag = interpolateWindMagnitude(grid, lon, lat);
      const [r, g, b, a] = getWindFieldColor(mag);
      const idx = ((py * width) + px) * 4;
      image.data[idx] = r;
      image.data[idx + 1] = g;
      image.data[idx + 2] = b;
      image.data[idx + 3] = mag == null ? 0 : Math.round(a * 0.82);
    }
  }

  ctx.putImageData(image, 0, 0);
  return {
    url: canvas.toDataURL("image/png"),
    bounds: [[south, west], [north, east]],
  };
}

function interpolateScalarGrid(grid, lon, lat) {
  const lon0 = Number(grid?.lon?.[0]);
  const lon1 = Number(grid?.lon?.[1] ?? lon0 + 0.25);
  const lat0 = Number(grid?.lat?.[0]);
  const lat1 = Number(grid?.lat?.[1] ?? lat0 - 0.25);
  const dx = Math.abs(lon1 - lon0) || 0.25;
  const dy = Math.abs(lat1 - lat0) || 0.25;
  const nx = Number(grid?.nx || 0);
  const ny = Number(grid?.ny || 0);
  if (!nx || !ny) return null;

  const x = (lon - lon0) / dx;
  const y = (lat0 - lat) / dy;
  const i = Math.floor(x);
  const j = Math.floor(y);
  if (i < 0 || j < 0 || i >= nx - 1 || j >= ny - 1) return null;
  const tx = x - i;
  const ty = y - j;
  const idx = (row, col) => (row * nx) + col;
  const v00 = Number(grid.values[idx(j, i)]);
  const v10 = Number(grid.values[idx(j, i + 1)]);
  const v01 = Number(grid.values[idx(j + 1, i)]);
  const v11 = Number(grid.values[idx(j + 1, i + 1)]);
  if (![v00, v10, v01, v11].every(Number.isFinite)) return null;
  const top = v00 + ((v10 - v00) * tx);
  const bottom = v01 + ((v11 - v01) * tx);
  return top + ((bottom - top) * ty);
}

function scalarMetricMapStyle(presetId, rawValue) {
  switch (presetId) {
    case "gfs-temp": {
      const f = kelvinToF(rawValue);
      const t = clamp((f + 10) / 110, 0, 1);
      return {
        displayValue: f,
        unit: "F",
        rgba: [
          Math.round(40 + (215 * t)),
          Math.round(120 + (70 * (1 - t))),
          Math.round(225 - (165 * t)),
          228,
        ],
      };
    }
    case "gfs-pressure": {
      const hpa = pascalsToHpa(rawValue);
      const t = clamp((hpa - 960) / 80, 0, 1);
      return {
        displayValue: hpa,
        unit: "hPa",
        rgba: [
          Math.round(34 + (26 * t)),
          Math.round(112 + (94 * t)),
          Math.round(168 + (42 * (1 - t))),
          220,
        ],
      };
    }
    case "gfs-humidity": {
      const pct = Number(rawValue);
      const t = clamp(pct / 100, 0, 1);
      return {
        displayValue: pct,
        unit: "%",
        rgba: [
          Math.round(32 + (18 * (1 - t))),
          Math.round(112 + (124 * t)),
          Math.round(78 + (92 * t)),
          220,
        ],
      };
    }
    case "gfs-cloud": {
      const pct = Number(rawValue);
      const t = clamp(pct / 100, 0, 1);
      const lifted = Math.pow(t, 0.82);
      const base = Math.round(72 + (168 * lifted));
      return {
        displayValue: pct,
        unit: "%",
        rgba: [base, Math.min(244, base + 10), Math.min(252, base + 18), Math.round(30 + (190 * lifted))],
      };
    }
    case "gfs-precip": {
      const mmhr = kilogramsPerSquareMeterPerSecondToMmPerHour(rawValue);
      const t = clamp(mmhr / 10, 0, 1);
      return {
        displayValue: mmhr,
        unit: "mm/hr",
        rgba: [
          Math.round(18 + (44 * (1 - t))),
          Math.round(92 + (110 * t)),
          Math.round(150 + (95 * t)),
          228,
        ],
      };
    }
    default:
      return {
        displayValue: Number(rawValue),
        unit: "",
        rgba: [59, 130, 246, 220],
      };
  }
}

function pseudoCloudNoise(lon, lat) {
  const n1 = Math.sin((lon * 0.17) + (lat * 0.11));
  const n2 = Math.sin((lon * 0.49) - (lat * 0.33));
  const n3 = Math.cos((lon * 0.93) + (lat * 0.71));
  return ((n1 * 0.5) + (n2 * 0.35) + (n3 * 0.15) + 1) * 0.5;
}

function renderCloudFieldOverlay(grid, bounds) {
  const { west, east, north, south, lonSpan, latSpan } = bounds;
  const baseWidth = 1600;
  const width = clamp(Math.round(baseWidth), 640, 1920);
  const height = clamp(Math.round(baseWidth * (latSpan / lonSpan)), 320, 1600);
  const workCanvas = document.createElement("canvas");
  workCanvas.width = width;
  workCanvas.height = height;
  const workCtx = workCanvas.getContext("2d");
  const image = workCtx.createImageData(width, height);

  for (let py = 0; py < height; py += 1) {
    const lat = north - ((py / Math.max(1, height - 1)) * latSpan);
    for (let px = 0; px < width; px += 1) {
      const lon = west + ((px / Math.max(1, width - 1)) * lonSpan);
      const raw = interpolateScalarGrid(grid, lon, lat);
      const idx = ((py * width) + px) * 4;
      if (raw == null) {
        image.data[idx + 3] = 0;
        continue;
      }
      const coverage = clamp(Number(raw) / 100, 0, 1);
      const shaped = Math.pow(clamp((coverage - 0.06) / 0.94, 0, 1), 0.78);
      const noise = pseudoCloudNoise(lon, lat);
      const texture = clamp((noise - 0.5) * 0.22, -0.1, 0.1);
      const density = clamp(shaped + texture, 0, 1);
      const brightness = Math.round(92 + (154 * Math.pow(density, 0.85)));
      image.data[idx] = brightness;
      image.data[idx + 1] = Math.min(248, brightness + 6);
      image.data[idx + 2] = Math.min(255, brightness + 14);
      image.data[idx + 3] = Math.round(14 + (214 * Math.pow(density, 1.15)));
    }
  }

  workCtx.putImageData(image, 0, 0);

  const finalCanvas = document.createElement("canvas");
  finalCanvas.width = width;
  finalCanvas.height = height;
  const finalCtx = finalCanvas.getContext("2d");
  finalCtx.imageSmoothingEnabled = true;
  finalCtx.drawImage(workCanvas, 0, 0);
  finalCtx.save();
  finalCtx.globalAlpha = 0.72;
  finalCtx.filter = "blur(2.4px)";
  finalCtx.drawImage(workCanvas, 0, 0);
  finalCtx.restore();
  finalCtx.save();
  finalCtx.globalAlpha = 0.28;
  finalCtx.filter = "blur(6px)";
  finalCtx.drawImage(workCanvas, 0, 0);
  finalCtx.restore();

  return {
    url: finalCanvas.toDataURL("image/png"),
    bounds: [[south, west], [north, east]],
  };
}

function renderScalarFieldOverlay(grid, presetId) {
  const west = Number(grid.lon[0]);
  const east = Number(grid.lon[grid.lon.length - 1]);
  const north = Number(grid.lat[0]);
  const south = Number(grid.lat[grid.lat.length - 1]);
  const lonSpan = Math.max(0.01, east - west);
  const latSpan = Math.max(0.01, north - south);
  if (presetId === "gfs-cloud") {
    return renderCloudFieldOverlay(grid, { west, east, north, south, lonSpan, latSpan });
  }
  const baseWidth = presetId === "gfs-cloud" ? 1024 : 768;
  const width = clamp(Math.round(baseWidth), 320, presetId === "gfs-cloud" ? 1280 : 960);
  const height = clamp(Math.round(baseWidth * (latSpan / lonSpan)), 220, presetId === "gfs-cloud" ? 1120 : 900);
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  const image = ctx.createImageData(width, height);

  for (let py = 0; py < height; py += 1) {
    const lat = north - ((py / Math.max(1, height - 1)) * latSpan);
    for (let px = 0; px < width; px += 1) {
      const lon = west + ((px / Math.max(1, width - 1)) * lonSpan);
      const raw = interpolateScalarGrid(grid, lon, lat);
      const { rgba } = scalarMetricMapStyle(presetId, raw);
      const idx = ((py * width) + px) * 4;
      image.data[idx] = rgba[0];
      image.data[idx + 1] = rgba[1];
      image.data[idx + 2] = rgba[2];
      image.data[idx + 3] = raw == null ? 0 : rgba[3];
    }
  }

  ctx.putImageData(image, 0, 0);
  return {
    url: canvas.toDataURL("image/png"),
    bounds: [[south, west], [north, east]],
  };
}

function metricLegendSpec(presetId) {
  switch (presetId) {
    case "gfs-wind":
      return {
        title: "Wind Speed",
        gradient: "linear-gradient(90deg, rgb(38,70,134), rgb(46,174,196), rgb(184,224,94), rgb(241,161,68), rgb(192,57,43), rgb(122,33,91))",
        ticks: ["0", "10", "20", "35", "50+ kt"],
      };
    case "gfs-temp":
      return {
        title: "Temperature",
        gradient: "linear-gradient(90deg, rgb(40,120,225), rgb(98,180,190), rgb(230,204,92), rgb(245,144,68), rgb(228,72,60))",
        ticks: ["0", "32", "50", "70", "90+ F"],
      };
    case "gfs-pressure":
      return {
        title: "Pressure",
        gradient: "linear-gradient(90deg, rgb(34,112,210), rgb(54,152,188), rgb(88,188,158), rgb(122,214,138), rgb(160,228,118))",
        ticks: ["960", "980", "1000", "1020", "1040 hPa"],
      };
    case "gfs-humidity":
      return {
        title: "Humidity",
        gradient: "linear-gradient(90deg, rgb(50,112,78), rgb(56,152,108), rgb(66,190,138), rgb(96,220,164), rgb(126,236,170))",
        ticks: ["0", "25", "50", "75", "100%"],
      };
    case "gfs-cloud":
      return {
        title: "Cloud Cover",
        gradient: "linear-gradient(90deg, rgb(55,63,73), rgb(95,105,118), rgb(140,150,164), rgb(188,196,208), rgb(230,238,248))",
        ticks: ["0", "25", "50", "75", "100%"],
      };
    case "gfs-precip":
      return {
        title: "Precip Rate",
        gradient: "linear-gradient(90deg, rgb(18,92,150), rgb(32,132,188), rgb(44,172,216), rgb(76,210,232), rgb(120,240,246))",
        ticks: ["0", "1", "3", "6", "10+ mm/hr"],
      };
    default:
      return null;
  }
}

function createMetricLegendControl(presetId) {
  const spec = metricLegendSpec(presetId);
  if (!spec) return null;
  const control = L.control({ position: "bottomright" });
  control.onAdd = () => {
    const el = L.DomUtil.create("div", "wind-legend-control");
    L.DomEvent.disableClickPropagation(el);
    el.innerHTML = `
      <div class="wind-legend-title">${esc(spec.title)}</div>
      <div class="wind-legend-bar" style="background:${spec.gradient};"></div>
      <div class="wind-legend-ticks">
        ${spec.ticks.map((tick) => `<span>${esc(tick)}</span>`).join("")}
      </div>
    `;
    return el;
  };
  return control;
}

async function fetchVectorMeta(vector) {
  const cacheKey = String(vector?.opendapUrl || "");
  if (VECTOR_META_CACHE.has(cacheKey)) return VECTOR_META_CACHE.get(cacheKey);

  const [dasRes, axesRes] = await Promise.all([
    fetch(`${vector.opendapUrl}.das`),
    fetch(`${vector.opendapUrl}.ascii?${vector.latVar},${vector.lonVar},${vector.timeVar},${vector.levelVar}`),
  ]);
  if (!dasRes.ok) throw new Error(`Time metadata failed: HTTP ${dasRes.status}`);
  if (!axesRes.ok) throw new Error(`Axis metadata failed: HTTP ${axesRes.status}`);

  const [dasText, axesText] = await Promise.all([dasRes.text(), axesRes.text()]);
  const lat = extractSimpleAsciiArray(axesText, vector.latVar);
  const lon = extractSimpleAsciiArray(axesText, vector.lonVar);
  const timeOffsets = extractSimpleAsciiArray(axesText, vector.timeVar);
  const levels = extractSimpleAsciiArray(axesText, vector.levelVar);
  const refTime = parseDasTimeBase(dasText, vector.timeVar);
  const baseMs = new Date(refTime).getTime();
  const times = timeOffsets.map((hours) => new Date(baseMs + (hours * 3600 * 1000)).toISOString());

  if (!lat.length || !lon.length || !times.length || !levels.length) {
    throw new Error("Incomplete wind metadata from GFS");
  }

  const meta = {
    lat,
    lon,
    times,
    timeOffsets,
    levelIndex: nearestValueIndex(levels, vector.levelValue),
    refTime,
  };
  VECTOR_META_CACHE.set(cacheKey, meta);
  return meta;
}

async function fetchUcarGfsWindData(vector, mapBounds, selectedIso, { maxCells = 24000 } = {}) {
  const meta = await fetchVectorMeta(vector);
  const targetIso = selectedIso || meta.times[Math.max(0, meta.times.length - 1)];
  const timeIndex = nearestTimeMetaIndex(meta.times, targetIso);

  const padDeg = 2;
  const south = Math.max(-90, mapBounds.getSouth() - padDeg);
  const north = Math.min(90, mapBounds.getNorth() + padDeg);
  const west = normalizeLon360(mapBounds.getWest() - padDeg);
  const east = normalizeLon360(mapBounds.getEast() + padDeg);
  if (west == null || east == null) throw new Error("Invalid map bounds");
  if (west > east) throw new Error("Wind particles do not support crossing the antimeridian yet");

  const [latStart, latEnd] = findDescendingRange(meta.lat, south, north);
  const [lonStart, lonEnd] = findAscendingRange(meta.lon, west, east);
  const latCount = latEnd - latStart + 1;
  const lonCount = lonEnd - lonStart + 1;
  const stride = estimateStride(latCount, lonCount, maxCells);
  const selector = `[${timeIndex}:1:${timeIndex}][${meta.levelIndex}:1:${meta.levelIndex}][${latStart}:${stride}:${latEnd}][${lonStart}:${stride}:${lonEnd}]`;
  const query = `${vector.uVar}${selector},${vector.vVar}${selector}`;

  const res = await fetch(`${vector.opendapUrl}.ascii?${query}`);
  if (!res.ok) throw new Error(`Wind data failed: HTTP ${res.status}`);
  const text = await res.text();
  const u = extractGridAscii(text, vector.uVar);
  const v = extractGridAscii(text, vector.vVar);
  const sampleIso = meta.times[timeIndex] || targetIso;
  const forecastHour = meta.timeOffsets[timeIndex] ?? 0;
  const refTime = meta.refTime || sampleIso;

  return {
    sampleIso,
    records: [
      buildVelocityRecord(u.data, u.lat, u.lon, refTime, forecastHour, 2),
      buildVelocityRecord(v.data, v.lat, v.lon, refTime, forecastHour, 3),
    ],
    grid: {
      lat: u.lat,
      lon: u.lon.map((value) => denormalizeLon(value)),
      nx: u.lon.length,
      ny: u.lat.length,
      magnitude: u.data.map((value, index) => {
        const uu = Number(value);
        const vv = Number(v.data[index]);
        return Math.sqrt((uu * uu) + (vv * vv));
      }),
    },
  };
}

async function fetchUcarGfsScalarGridData(sample, mapBounds, selectedIso, { maxCells = 24000 } = {}) {
  const meta = await fetchPointMeta(sample);
  const targetIso = selectedIso || meta.times[Math.max(0, meta.times.length - 1)];
  const timeIndex = nearestTimeMetaIndex(meta.times, targetIso);

  const padDeg = 2;
  const south = Math.max(-90, mapBounds.getSouth() - padDeg);
  const north = Math.min(90, mapBounds.getNorth() + padDeg);
  const west = normalizeLon360(mapBounds.getWest() - padDeg);
  const east = normalizeLon360(mapBounds.getEast() + padDeg);
  if (west == null || east == null) throw new Error("Invalid map bounds");
  if (west > east) throw new Error("Scalar overlays do not support crossing the antimeridian yet");

  const latDescending = Number(meta.lat[0]) > Number(meta.lat[meta.lat.length - 1]);
  const [latStart, latEnd] = latDescending
    ? findDescendingRange(meta.lat, south, north)
    : findAscendingRange(meta.lat, south, north);
  const [lonStart, lonEnd] = findAscendingRange(meta.lon, west, east);
  const latCount = latEnd - latStart + 1;
  const lonCount = lonEnd - lonStart + 1;
  const stride = estimateStride(latCount, lonCount, maxCells);
  const selector = sample.levelVar
    ? `[${timeIndex}:1:${timeIndex}][${meta.levelIndex}:1:${meta.levelIndex}][${latStart}:${stride}:${latEnd}][${lonStart}:${stride}:${lonEnd}]`
    : `[${timeIndex}:1:${timeIndex}][${latStart}:${stride}:${latEnd}][${lonStart}:${stride}:${lonEnd}]`;

  const res = await fetch(`${sample.opendapUrl}.ascii?${sample.scalarVar}${selector}`);
  if (!res.ok) throw new Error(`Scalar data failed: HTTP ${res.status}`);
  const text = await res.text();
  const scalar = extractGridAscii(text, sample.scalarVar);
  return {
    sampleIso: meta.times[timeIndex] || targetIso,
    grid: {
      lat: scalar.lat,
      lon: scalar.lon.map((value) => denormalizeLon(value)),
      nx: scalar.lon.length,
      ny: scalar.lat.length,
      values: scalar.data,
    },
  };
}

function bearingFromUV(u, v) {
  const angle = (Math.atan2(Number(u) || 0, Number(v) || 0) * 180) / Math.PI;
  return ((angle + 360) % 360);
}

function cardinalFromBearing(deg) {
  const dirs = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];
  const idx = Math.round((((Number(deg) || 0) % 360) / 45)) % dirs.length;
  return dirs[idx];
}

function kelvinToC(k) {
  return Number(k) - 273.15;
}

function kelvinToF(k) {
  return (kelvinToC(k) * 9) / 5 + 32;
}

function metersPerSecondToKnots(value) {
  return Number(value) * 1.9438444924406;
}

function pascalsToHpa(value) {
  return Number(value) / 100;
}

function kilogramsPerSquareMeterPerSecondToMmPerHour(value) {
  return Number(value) * 3600;
}

function metricButtonSet() {
  return [
    "gfs-wind",
    "gfs-temp",
    "gfs-pressure",
    "gfs-humidity",
    "gfs-cloud",
    "gfs-precip",
  ];
}

function metricButtonLabel(presetId) {
  return ({
    "gfs-wind": "Wind",
    "gfs-temp": "Temp",
    "gfs-pressure": "Pressure",
    "gfs-humidity": "Humidity",
    "gfs-cloud": "Cloud",
    "gfs-precip": "Precip",
  })[presetId] || presetId;
}

function metricChartConfig(presetId) {
  switch (presetId) {
    case "gfs-wind":
      return {
        mode: "wind",
        unitLabel: "kt",
        valueFromRow: (row) => Number(row.speedKt),
        rawFromRow: (row) => Number(row.speed),
        overlayPresetId: "gfs-gust",
        overlayValueFromRow: (row) => metersPerSecondToKnots(row.value),
        colorFromValue: (_value, row) => {
          const [r, g, b] = getWindFieldColor(Number(row?.speed) || 0).slice(0, 3);
          return `rgb(${r}, ${g}, ${b})`;
        },
        formatReadout(iso, value, overlay, timeZone) {
          const dt = new Date(String(iso || ""));
          const label = Number.isFinite(dt.getTime())
            ? new Intl.DateTimeFormat(undefined, {
              weekday: "short",
              month: "short",
              day: "2-digit",
              hour: "numeric",
              minute: "2-digit",
              timeZone,
              timeZoneName: "short",
            }).format(dt)
            : String(iso || "");
          return overlay != null
            ? `${label} · ${Number(value).toFixed(1)} kt wind · ${Number(overlay).toFixed(1)} kt gust`
            : `${label} · ${Number(value).toFixed(1)} kt wind`;
        },
      };
    case "gfs-temp":
      return {
        mode: "scalar",
        unitLabel: "F",
        valueFromRow: (row) => Number(row.fahrenheit),
        colorFromValue: (value) => {
          const t = Math.max(0, Math.min(1, (Number(value) + 10) / 110));
          return `rgb(${Math.round(48 + (215 * t))}, ${Math.round(110 + (80 * (1 - t)))}, ${Math.round(220 - (170 * t))})`;
        },
        formatReadout: formatScalarReadout("F"),
      };
    case "gfs-pressure":
      return {
        mode: "scalar",
        unitLabel: "hPa",
        valueFromRow: (row) => pascalsToHpa(row.value),
        colorFromValue: (value) => {
          const t = Math.max(0, Math.min(1, (Number(value) - 960) / 80));
          return `rgb(${Math.round(35 + (50 * t))}, ${Math.round(120 + (80 * t))}, ${Math.round(160 + (70 * (1 - t)))})`;
        },
        formatReadout: formatScalarReadout("hPa"),
      };
    case "gfs-humidity":
      return {
        mode: "scalar",
        unitLabel: "%",
        valueFromRow: (row) => Number(row.value),
        colorFromValue: (value) => {
          const t = Math.max(0, Math.min(1, Number(value) / 100));
          return `rgb(${Math.round(30 + (40 * (1 - t)))}, ${Math.round(110 + (120 * t))}, ${Math.round(90 + (70 * (1 - t)))})`;
        },
        formatReadout: formatScalarReadout("%"),
      };
    case "gfs-cloud":
      return {
        mode: "scalar",
        unitLabel: "%",
        valueFromRow: (row) => Number(row.value),
        colorFromValue: (value) => {
          const t = Math.max(0, Math.min(1, Number(value) / 100));
          const v = Math.round(60 + (155 * t));
          return `rgb(${v}, ${v + 10}, ${Math.max(80, v + 20)})`;
        },
        formatReadout: formatScalarReadout("%"),
      };
    case "gfs-precip":
      return {
        mode: "scalar",
        unitLabel: "mm/hr",
        valueFromRow: (row) => kilogramsPerSquareMeterPerSecondToMmPerHour(row.value),
        colorFromValue: (value) => {
          const t = Math.max(0, Math.min(1, Number(value) / 10));
          return `rgb(${Math.round(20 + (40 * (1 - t)))}, ${Math.round(90 + (100 * t))}, ${Math.round(150 + (90 * t))})`;
        },
        formatReadout: formatScalarReadout("mm/hr"),
      };
    default:
      return {
        mode: "scalar",
        unitLabel: "",
        valueFromRow: (row) => Number(row.value),
        colorFromValue: () => "rgb(59, 130, 246)",
        formatReadout: formatScalarReadout(""),
      };
  }
}

function formatScalarReadout(unitLabel) {
  return (iso, value, _overlay, timeZone) => {
    const dt = new Date(String(iso || ""));
    const label = Number.isFinite(dt.getTime())
      ? new Intl.DateTimeFormat(undefined, {
        weekday: "short",
        month: "short",
        day: "2-digit",
        hour: "numeric",
        minute: "2-digit",
        timeZone,
        timeZoneName: "short",
      }).format(dt)
      : String(iso || "");
    return `${label} · ${Number(value).toFixed(1)} ${unitLabel}`.trim();
  };
}

function makePointSampleCacheKey(sample, lat, lon, iso) {
  return JSON.stringify({
    type: sample?.type || "",
    scalarVar: sample?.scalarVar || "",
    uVar: sample?.uVar || "",
    vVar: sample?.vVar || "",
    levelVar: sample?.levelVar || "",
    levelValue: sample?.levelValue ?? null,
    lat: Number(lat).toFixed(4),
    lon: Number(lon).toFixed(4),
    iso: String(iso || ""),
  });
}

function makePointSeriesCacheKey(sample, lat, lon) {
  return JSON.stringify({
    type: sample?.type || "",
    scalarVar: sample?.scalarVar || "",
    uVar: sample?.uVar || "",
    vVar: sample?.vVar || "",
    levelVar: sample?.levelVar || "",
    levelValue: sample?.levelValue ?? null,
    lat: Number(lat).toFixed(4),
    lon: Number(lon).toFixed(4),
  });
}

async function fetchPointMeta(sample) {
  const key = JSON.stringify({
    url: sample?.opendapUrl || "",
    timeVar: sample?.timeVar || "",
    latVar: sample?.latVar || "",
    lonVar: sample?.lonVar || "",
    levelVar: sample?.levelVar || "",
  });
  if (POINT_META_CACHE.has(key)) return POINT_META_CACHE.get(key);

  const parts = [sample.latVar, sample.lonVar, sample.timeVar];
  if (sample.levelVar) parts.push(sample.levelVar);
  const [dasRes, axesRes] = await Promise.all([
    fetch(`${sample.opendapUrl}.das`),
    fetch(`${sample.opendapUrl}.ascii?${parts.join(",")}`),
  ]);
  if (!dasRes.ok) throw new Error(`Point metadata failed: HTTP ${dasRes.status}`);
  if (!axesRes.ok) throw new Error(`Point axes failed: HTTP ${axesRes.status}`);
  const [dasText, axesText] = await Promise.all([dasRes.text(), axesRes.text()]);
  const lat = extractSimpleAsciiArray(axesText, sample.latVar);
  const lon = extractSimpleAsciiArray(axesText, sample.lonVar);
  const timeOffsets = extractSimpleAsciiArray(axesText, sample.timeVar);
  const levels = sample.levelVar ? extractSimpleAsciiArray(axesText, sample.levelVar) : [];
  const refTime = parseDasTimeBase(dasText, sample.timeVar);
  const baseMs = new Date(refTime).getTime();
  const times = timeOffsets.map((hours) => new Date(baseMs + (hours * 3600 * 1000)).toISOString());
  if (!lat.length || !lon.length || !times.length) throw new Error("Incomplete point metadata");
  const meta = {
    lat,
    lon,
    times,
    timeOffsets,
    refTime,
    levelIndex: sample.levelVar ? nearestValueIndex(levels, sample.levelValue) : null,
  };
  POINT_META_CACHE.set(key, meta);
  return meta;
}

async function fetchUcarGfsPointSample(sample, lat, lon, selectedIso) {
  const meta = await fetchPointMeta(sample);
  const latIndex = nearestValueIndex(meta.lat, lat);
  const lonIndex = nearestValueIndex(meta.lon, normalizeLon360(lon));
  const timeIndex = nearestTimeMetaIndex(meta.times, selectedIso || meta.times[Math.max(0, meta.times.length - 1)]);
  const pointSelector = sample.levelVar
    ? `[${timeIndex}:1:${timeIndex}][${meta.levelIndex}:1:${meta.levelIndex}][${latIndex}:1:${latIndex}][${lonIndex}:1:${lonIndex}]`
    : `[${timeIndex}:1:${timeIndex}][${latIndex}:1:${latIndex}][${lonIndex}:1:${lonIndex}]`;
  const vars = sample.type === "ucar-gfs-vector-point"
    ? `${sample.uVar}${pointSelector},${sample.vVar}${pointSelector}`
    : `${sample.scalarVar}${pointSelector}`;
  const res = await fetch(`${sample.opendapUrl}.ascii?${vars}`);
  if (!res.ok) throw new Error(`Point sample failed: HTTP ${res.status}`);
  const text = await res.text();
  const sampleIso = meta.times[timeIndex];
  const actualLat = Number(meta.lat[latIndex]);
  const actualLon360 = Number(meta.lon[lonIndex]);
  const actualLon = actualLon360 > 180 ? actualLon360 - 360 : actualLon360;

  if (sample.type === "ucar-gfs-vector-point") {
    const u = extractSingleGridValue(text, sample.uVar);
    const v = extractSingleGridValue(text, sample.vVar);
    const speed = Math.sqrt((u * u) + (v * v));
    const bearing = bearingFromUV(u, v);
    return {
      kind: "vector",
      label: sample.label,
      sampleIso,
      actualLat,
      actualLon,
      values: {
        u,
        v,
        speed,
        speedKt: metersPerSecondToKnots(speed),
        bearing,
        cardinal: cardinalFromBearing(bearing),
      },
    };
  }

  const value = extractSingleGridValue(text, sample.scalarVar);
  return {
    kind: "scalar",
    label: sample.label,
    sampleIso,
    actualLat,
    actualLon,
    values: {
      value,
      celsius: sample.unit === "K" ? kelvinToC(value) : null,
      fahrenheit: sample.unit === "K" ? kelvinToF(value) : null,
      unit: sample.unit,
    },
  };
}

async function fetchUcarGfsPointSeries(sample, lat, lon) {
  const meta = await fetchPointMeta(sample);
  const latIndex = nearestValueIndex(meta.lat, lat);
  const lonIndex = nearestValueIndex(meta.lon, normalizeLon360(lon));
  const lastTimeIndex = Math.max(0, meta.times.length - 1);
  const pointSelector = sample.levelVar
    ? `[0:1:${lastTimeIndex}][${meta.levelIndex}:1:${meta.levelIndex}][${latIndex}:1:${latIndex}][${lonIndex}:1:${lonIndex}]`
    : `[0:1:${lastTimeIndex}][${latIndex}:1:${latIndex}][${lonIndex}:1:${lonIndex}]`;
  const vars = sample.type === "ucar-gfs-vector-point"
    ? `${sample.uVar}${pointSelector},${sample.vVar}${pointSelector}`
    : `${sample.scalarVar}${pointSelector}`;
  const res = await fetch(`${sample.opendapUrl}.ascii?${vars}`);
  if (!res.ok) throw new Error(`Point series failed: HTTP ${res.status}`);
  const text = await res.text();
  const actualLat = Number(meta.lat[latIndex]);
  const actualLon360 = Number(meta.lon[lonIndex]);
  const actualLon = actualLon360 > 180 ? actualLon360 - 360 : actualLon360;

  if (sample.type === "ucar-gfs-vector-point") {
    const uValues = extractSeriesGridValues(text, sample.uVar);
    const vValues = extractSeriesGridValues(text, sample.vVar);
    const series = meta.times.map((iso, index) => {
      const u = Number(uValues[index]);
      const v = Number(vValues[index]);
      const speed = Math.sqrt((u * u) + (v * v));
      const bearing = bearingFromUV(u, v);
      return {
        iso,
        u,
        v,
        speed,
        speedKt: metersPerSecondToKnots(speed),
        bearing,
        cardinal: cardinalFromBearing(bearing),
      };
    }).filter((row) => Number.isFinite(row.speedKt));
    return {
      kind: "vector",
      actualLat,
      actualLon,
      series,
    };
  }

  const values = extractSeriesGridValues(text, sample.scalarVar);
  return {
    kind: "scalar",
    actualLat,
    actualLon,
    series: meta.times.map((iso, index) => ({
      iso,
      value: Number(values[index]),
      celsius: sample.unit === "K" ? kelvinToC(values[index]) : null,
      fahrenheit: sample.unit === "K" ? kelvinToF(values[index]) : null,
    })).filter((row) => Number.isFinite(row.value)),
  };
}

function nearestTimeIndex(times) {
  if (!Array.isArray(times) || !times.length) return 0;
  const now = Date.now();
  let best = 0;
  let bestDist = Number.POSITIVE_INFINITY;
  times.forEach((iso, i) => {
    const ms = new Date(String(iso || "")).getTime();
    if (!Number.isFinite(ms)) return;
    const d = Math.abs(ms - now);
    if (d < bestDist) {
      bestDist = d;
      best = i;
    }
  });
  return best;
}

export const realtimeWeatherTool = {
  id: "realtime-weather",
  name: "Realtime Weather",
  init(app) { this._rt = this._rt ?? createRuntime(app); },
  destroy() { this._rt?.destroy?.(); this._rt = null; },
  renderPanel(app, containerEl) {
    if (!this._rt) this._rt = createRuntime(app);
    this._rt.mount(containerEl);
  },
};

function createRuntime(app) {
  let containerEl = null;
  let state = readState();
  let status = "";
  let loading = false;
  let offLayersChanged = null;
  let offMapClick = null;
  let offKeydown = null;
  let bottomMounted = false;
  let animation = {
    globalLayerId: null,
    layerA: null,
    layerB: null,
    activeKey: "a",
    source: null,
    times: [],
    index: 0,
    playing: false,
    playToken: 0,
    transitioning: false,
    visible: true,
    opacity: Math.max(0, Math.min(1, Number(state.opacity) || 0.75)),
  };
  let picker = {
    enabled: state.pickerEnabled === true,
    loading: false,
    marker: null,
    sample: null,
    latlng: null,
    token: 0,
  };
  let serviceTimeline = {
    presetId: "",
    times: [],
    loading: false,
    error: "",
    source: "fallback",
  };
  let forecastSeries = {
    presetId: "",
    anchorKey: "",
    anchorLabel: "",
    loading: false,
    error: "",
    mode: "scalar",
    rows: [],
    overlayRows: [],
  };
  let activeForecastLayer = {
    presetId: "",
    layerId: "",
    refresh: null,
  };
  let lastForecastRefreshServiceIso = "";
  const pointSampleCache = new Map();
  const pointSeriesCache = new Map();
  let forecastPlayer = {
    playing: false,
    token: 0,
  };
  let forecastChartScrollLeft = 0;

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, Math.max(0, Number(ms) || 0)));
  }

  function activeLayer() {
    return animation.activeKey === "a" ? animation.layerA : animation.layerB;
  }

  function inactiveLayer() {
    return animation.activeKey === "a" ? animation.layerB : animation.layerA;
  }

  function setTimelineUi() {
    const slider = containerEl?.querySelector?.("#wx-time-idx");
    const label = containerEl?.querySelector?.("#wx-time-label");
    if (slider) slider.value = String(animation.index);
    if (label) label.textContent = fmtIso(animation.times[animation.index] || "");
  }

  function waitForLayerLoad(layer, timeoutMs = 2200) {
    return new Promise((resolve) => {
      if (!layer) { resolve(false); return; }
      let done = false;
      const finish = (ok) => {
        if (done) return;
        done = true;
        cleanup();
        resolve(ok);
      };
      const onLoad = () => finish(true);
      const onError = () => finish(false);
      const timer = setTimeout(() => finish(false), timeoutMs);
      const cleanup = () => {
        clearTimeout(timer);
        try { layer.off("load", onLoad); } catch {}
        try { layer.off("tileerror", onError); } catch {}
      };
      try { layer.on("load", onLoad); } catch {}
      try { layer.on("tileerror", onError); } catch {}
    });
  }

  function fadeLayers(fromLayer, toLayer, targetOpacity, durationMs) {
    return new Promise((resolve) => {
      const start = performance.now();
      const dur = Math.max(80, Number(durationMs) || 200);
      const step = () => {
        const t = Math.min(1, (performance.now() - start) / dur);
        const eased = t * (2 - t);
        const toOpacity = targetOpacity * eased;
        const fromOpacity = targetOpacity * (1 - eased);
        try { toLayer?.setOpacity?.(toOpacity); } catch {}
        try { fromLayer?.setOpacity?.(fromOpacity); } catch {}
        if (t >= 1) {
          try { toLayer?.setOpacity?.(targetOpacity); } catch {}
          try { fromLayer?.setOpacity?.(0); } catch {}
          resolve();
        } else {
          requestAnimationFrame(step);
        }
      };
      requestAnimationFrame(step);
    });
  }

  function fadeManagedLayerOpacity(fromLayerId, toLayerId, targetOpacity, durationMs) {
    return new Promise((resolve) => {
      const start = performance.now();
      const dur = Math.max(120, Number(durationMs) || 220);
      const step = () => {
        const t = Math.min(1, (performance.now() - start) / dur);
        const eased = t * (2 - t);
        const toOpacity = targetOpacity * eased;
        const fromOpacity = targetOpacity * (1 - eased);
        try { if (toLayerId) app.services.layers.setOpacity(toLayerId, toOpacity, { emit: false, persist: false }); } catch {}
        try { if (fromLayerId) app.services.layers.setOpacity(fromLayerId, fromOpacity, { emit: false, persist: false }); } catch {}
        if (t >= 1) {
          try { if (toLayerId) app.services.layers.setOpacity(toLayerId, targetOpacity, { emit: false, persist: false }); } catch {}
          try { if (fromLayerId) app.services.layers.setOpacity(fromLayerId, 0, { emit: false, persist: false }); } catch {}
          resolve();
        } else {
          requestAnimationFrame(step);
        }
      };
      requestAnimationFrame(step);
    });
  }

  function currentPreset() {
    return GLOBAL_PRESETS.find((p) => p.id === state.presetId) || GLOBAL_PRESETS[0];
  }

  function presetById(id) {
    return GLOBAL_PRESETS.find((p) => p.id === id) || null;
  }

  function selectedTimeIso() {
    if (state.timeMode !== "specific") return null;
    return toWmsTime(state.timeLocal);
  }

  function currentSampleConfig() {
    return currentPreset()?.sample || null;
  }

  function clearActiveForecastLayer() {
    if (!activeForecastLayer.layerId) {
      activeForecastLayer = { presetId: "", layerId: "", refresh: null };
      return;
    }
    try { app.services.layers.removeLayer(activeForecastLayer.layerId); } catch {}
    activeForecastLayer = { presetId: "", layerId: "", refresh: null };
  }

  function setActiveForecastLayerVisibility(nextVisible) {
    const visible = !!nextVisible;
    state = { ...state, layerVisible: visible };
    saveState(state);
    if (activeForecastLayer.layerId) {
      try { app.services.layers.setVisible(activeForecastLayer.layerId, visible); } catch {}
    }
    render();
    renderBottomPanelOnly();
  }

  async function setActiveMetric(metricId) {
    const preset = presetById(metricId);
    if (!preset || preset.id === state.presetId) return;
    const previousLayerId = activeForecastLayer.layerId || "";
    state = { ...state, presetId: preset.id };
    if (picker.enabled && !preset.sample) picker.enabled = false;
    saveState(state);
    render();
    renderBottomPanelOnly();
    await ensureServiceTimeline(preset, { force: true });
    await activateCurrentMetricLayer({ preserveExisting: !!previousLayerId, initialOpacity: previousLayerId && state.layerVisible !== false ? 0 : Math.max(0, Math.min(1, Number(state.opacity) || 0.75)) });
    if (previousLayerId && activeForecastLayer.layerId && previousLayerId !== activeForecastLayer.layerId) {
      if (state.layerVisible !== false) {
        await fadeManagedLayerOpacity(
          previousLayerId,
          activeForecastLayer.layerId,
          Math.max(0, Math.min(1, Number(state.opacity) || 0.75)),
          240,
        );
      }
      try { app.services.layers.removeLayer(previousLayerId); } catch {}
    }
    lastForecastRefreshServiceIso = currentServiceFrameIso();
    if (picker.latlng && preset.sample) {
      await sampleCurrentPresetAt(picker.latlng);
    } else {
      await ensureForecastSeries({ force: true });
      renderBottomPanelOnly();
    }
  }

  async function prefetchPinnedMetricData(latlng) {
    if (!latlng) return;
    const specificIso = selectedTimeIso();
    const metrics = metricButtonSet()
      .map((id) => presetById(id))
      .filter((preset) => preset?.sample);
    for (const preset of metrics) {
      const sample = preset.sample;
      const sampleKey = makePointSampleCacheKey(sample, latlng.lat, latlng.lng, specificIso);
      const seriesKey = makePointSeriesCacheKey(sample, latlng.lat, latlng.lng);
      try {
        if (!pointSampleCache.has(sampleKey)) {
          const result = await fetchUcarGfsPointSample(sample, latlng.lat, latlng.lng, specificIso);
          pointSampleCache.set(sampleKey, result);
        }
      } catch (err) {
        console.warn("[RealtimeWeather] point sample prefetch failed", preset.id, err);
      }
      try {
        if (!pointSeriesCache.has(seriesKey)) {
          const result = await fetchUcarGfsPointSeries(sample, latlng.lat, latlng.lng);
          pointSeriesCache.set(seriesKey, result);
        }
      } catch (err) {
        console.warn("[RealtimeWeather] point series prefetch failed", preset.id, err);
      }
    }
  }

  async function readServiceTimesForPreset(preset) {
    if (!preset) return [];
    if (preset.vector?.opendapUrl) {
      const meta = await fetchVectorMeta(preset.vector);
      return Array.isArray(meta?.times) ? meta.times.filter(Boolean) : [];
    }
    if (preset.sample?.opendapUrl) {
      const meta = await fetchPointMeta(preset.sample);
      return Array.isArray(meta?.times) ? meta.times.filter(Boolean) : [];
    }
    return [];
  }

  async function ensureServiceTimeline(preset = currentPreset(), { force = false } = {}) {
    if (!preset) return;
    if (!force && serviceTimeline.presetId === preset.id && (serviceTimeline.loading || serviceTimeline.times.length)) return;
    serviceTimeline = {
      presetId: preset.id,
      times: force ? [] : serviceTimeline.times,
      loading: true,
      error: "",
      source: "service",
    };
    renderBottomPanelOnly();
    try {
      const times = await readServiceTimesForPreset(preset);
      serviceTimeline = {
        presetId: preset.id,
        times,
        loading: false,
        error: "",
        source: times.length ? "service" : "fallback",
      };
    } catch (err) {
      console.warn("[RealtimeWeather] service timeline load failed", err);
      serviceTimeline = {
        presetId: preset.id,
        times: [],
        loading: false,
        error: err?.message || String(err),
        source: "fallback",
      };
    }
    renderBottomPanelOnly();
  }

  function forecastTimesForPreset() {
    const preset = currentPreset();
    const sourceTimes = Array.isArray(serviceTimeline.times) && serviceTimeline.presetId === preset?.id && serviceTimeline.times.length
      ? serviceTimeline.times
      : (Array.isArray(animation.times) && animation.source?.id === preset?.id && animation.times.length
        ? animation.times
        : generateFallbackTimes(preset));
    return sourceTimes.filter(Boolean);
  }

  function forecastStepTimes() {
    const preset = currentPreset();
    if (forecastSeries.presetId === preset?.id && Array.isArray(forecastSeries.rows) && forecastSeries.rows.length) {
      const chartConfig = metricChartConfig(preset.id);
      return buildHourlyChartRows(forecastSeries.rows, forecastTimesForPreset(), chartConfig.valueFromRow).map((row) => row.iso);
    }
    return forecastTimesForPreset();
  }

  function currentServiceFrameIso() {
    const times = forecastTimesForPreset();
    if (!times.length) return "";
    const targetIso = selectedTimeIso() || times[nearestTimeIndex(times)] || times[times.length - 1];
    return times[nearestTimeMetaIndex(times, targetIso)] || "";
  }

  function selectedForecastIsoFromState(times = forecastStepTimes()) {
    if (!times.length) return null;
    if (state.timeMode === "specific") {
      const specificIso = selectedTimeIso();
      if (specificIso) return times[nearestTimeMetaIndex(times, specificIso)] || specificIso;
    }
    return times[nearestTimeIndex(times)] || null;
  }

  function setForecastSelection(iso, { latest = false } = {}) {
    if (latest || !iso) {
      state = { ...state, timeMode: "latest", timeLocal: "" };
    } else {
      const ms = new Date(String(iso || "")).getTime();
      state = {
        ...state,
        timeMode: "specific",
        timeLocal: Number.isFinite(ms) ? toLocalInputValue(ms) : state.timeLocal,
      };
    }
    saveState(state);
    render();
    updateBottomPanelSelectionUi();
    refreshForecastDrivenViews();
  }

  function stopForecastPlayback() {
    forecastPlayer.playing = false;
    forecastPlayer.token += 1;
    updateBottomPanelPlaybackUi();
  }

  async function startForecastPlayback() {
    const times = forecastStepTimes();
    if (times.length < 2) return;
    stopForecastPlayback();
    forecastPlayer.playing = true;
    const token = ++forecastPlayer.token;
    updateBottomPanelPlaybackUi();
    while (forecastPlayer.playing && token === forecastPlayer.token) {
      const activeTimes = forecastStepTimes();
      const selectedIso = selectedForecastIsoFromState(activeTimes);
      const idx = Math.max(0, activeTimes.findIndex((v) => v === selectedIso));
      const nextIso = activeTimes[(idx + 1) % activeTimes.length] || activeTimes[0];
      setForecastSelection(nextIso);
      const waitMs = Math.max(180, Math.round((Number(state.playbackMs) || 800) / Math.max(1, Number(state.playbackRate) || 1)));
      await sleep(waitMs);
      if (!forecastPlayer.playing || token !== forecastPlayer.token) break;
    }
  }

  function syncPickerCursor() {
    const container = app.map.instance?.getContainer?.();
    if (!container) return;
    container.style.cursor = picker.enabled ? "crosshair" : "";
  }

  function clearPickerMarker() {
    if (picker.marker && app.map.instance.hasLayer(picker.marker)) app.map.instance.removeLayer(picker.marker);
    picker.marker = null;
    picker.latlng = null;
  }

  function setPickerMarker(latlng) {
    clearPickerMarker();
    picker.latlng = latlng ? L.latLng(latlng.lat, latlng.lng) : null;
    picker.marker = L.circleMarker(latlng, {
      radius: 6,
      color: "#111827",
      weight: 2,
      fillColor: "#f59e0b",
      fillOpacity: 0.95,
    }).addTo(app.map.instance);
  }

  function formatSampleSummary(sample) {
    if (!sample) return "";
    if (sample.kind === "vector") {
      return `${sample.label}: ${sample.values.speedKt.toFixed(1)} kt ${sample.values.cardinal} (${sample.values.bearing.toFixed(0)}deg)`;
    }
    if (sample.kind === "scalar" && Number.isFinite(sample.values.celsius)) {
      return `${sample.label}: ${sample.values.celsius.toFixed(1)} C / ${sample.values.fahrenheit.toFixed(1)} F`;
    }
    if (sample.kind === "scalar" && sample.values.unit === "Pa") {
      return `${sample.label}: ${pascalsToHpa(sample.values.value).toFixed(1)} hPa`;
    }
    if (sample.kind === "scalar" && sample.values.unit === "kg/m2/s") {
      return `${sample.label}: ${kilogramsPerSquareMeterPerSecondToMmPerHour(sample.values.value).toFixed(2)} mm/hr`;
    }
    if (sample.kind === "scalar" && sample.values.unit === "m/s") {
      return `${sample.label}: ${metersPerSecondToKnots(sample.values.value).toFixed(1)} kt`;
    }
    if (sample.kind === "scalar") {
      return `${sample.label}: ${sample.values.value.toFixed(2)} ${sample.values.unit || ""}`.trim();
    }
    return "";
  }

  function buildHourlyChartRows(rows, serviceTimes, valueAccessor) {
    if (!Array.isArray(rows) || rows.length < 1) return [];
    const sorted = rows
      .slice()
      .filter((row) => row && Number.isFinite(new Date(row.iso).getTime()) && Number.isFinite(Number(valueAccessor(row))))
      .sort((a, b) => new Date(a.iso).getTime() - new Date(b.iso).getTime());
    if (!sorted.length) return [];
    const out = [];
    const firstMs = new Date(sorted[0].iso).getTime();
    const lastMs = new Date(sorted[sorted.length - 1].iso).getTime();
    const hourMs = 3600 * 1000;
    for (let ms = firstMs; ms <= lastMs; ms += hourMs) {
      let prev = sorted[0];
      let next = sorted[sorted.length - 1];
      for (let i = 0; i < sorted.length; i += 1) {
        const rowMs = new Date(sorted[i].iso).getTime();
        if (rowMs <= ms) prev = sorted[i];
        if (rowMs >= ms) {
          next = sorted[i];
          break;
        }
      }
      const prevMs = new Date(prev.iso).getTime();
      const nextMs = new Date(next.iso).getTime();
      const spanMs = Math.max(1, nextMs - prevMs);
      const t = prevMs === nextMs ? 0 : (ms - prevMs) / spanMs;
      const prevValue = Number(valueAccessor(prev));
      const nextValue = Number(valueAccessor(next));
      const value = prevValue + ((nextValue - prevValue) * t);
      const nearestIdx = nearestTimeMetaIndex(serviceTimes, new Date(ms).toISOString());
      const selectIso = serviceTimes[nearestIdx] || prev.iso;
      out.push({
        iso: new Date(ms).toISOString(),
        value,
        actual: sorted.some((row) => row.iso === new Date(ms).toISOString()),
        selectIso,
      });
    }
    return out;
  }

  function getForecastAnchor() {
    const ll = picker.latlng || app.map.instance?.getCenter?.() || null;
    if (!ll) return null;
    return {
      latlng: L.latLng(ll.lat, ll.lng),
      label: picker.latlng ? "Picked point" : "Map center",
      key: `${picker.latlng ? "pick" : "center"}:${Number(ll.lat).toFixed(3)},${Number(ll.lng).toFixed(3)}`,
    };
  }

  async function ensureForecastSeries({ force = false, suppressRender = false } = {}) {
    const preset = currentPreset();
    const sample = currentSampleConfig();
    const anchor = getForecastAnchor();
    if (!sample || !anchor) {
      forecastSeries = {
        presetId: preset?.id || "",
        anchorKey: "",
        anchorLabel: "",
        loading: false,
        error: "",
        mode: "scalar",
        rows: [],
        overlayRows: [],
      };
      return;
    }
    if (!force && forecastSeries.presetId === preset.id && forecastSeries.anchorKey === anchor.key && (forecastSeries.loading || forecastSeries.rows.length)) return;
    forecastSeries = {
      presetId: preset.id,
      anchorKey: anchor.key,
      anchorLabel: anchor.label,
      loading: true,
      error: "",
      mode: metricChartConfig(preset.id).mode,
      rows: force ? [] : forecastSeries.rows,
      overlayRows: [],
    };
    if (!suppressRender) renderBottomPanelOnly();
    try {
      const seriesKey = makePointSeriesCacheKey(sample, anchor.latlng.lat, anchor.latlng.lng);
      const result = (!force && pointSeriesCache.has(seriesKey))
        ? pointSeriesCache.get(seriesKey)
        : await fetchUcarGfsPointSeries(sample, anchor.latlng.lat, anchor.latlng.lng);
      pointSeriesCache.set(seriesKey, result);
      let overlayRows = [];
      if (preset.id === "gfs-wind") {
        const gustPreset = GLOBAL_PRESETS.find((entry) => entry.id === "gfs-gust");
        if (gustPreset?.sample) {
          try {
            const gustKey = makePointSeriesCacheKey(gustPreset.sample, anchor.latlng.lat, anchor.latlng.lng);
            const gustResult = (!force && pointSeriesCache.has(gustKey))
              ? pointSeriesCache.get(gustKey)
              : await fetchUcarGfsPointSeries(gustPreset.sample, anchor.latlng.lat, anchor.latlng.lng);
            pointSeriesCache.set(gustKey, gustResult);
            overlayRows = Array.isArray(gustResult?.series) ? gustResult.series : [];
          } catch (gustErr) {
            console.warn("[RealtimeWeather] gust series unavailable", gustErr);
          }
        }
      }
      forecastSeries = {
        presetId: preset.id,
        anchorKey: anchor.key,
        anchorLabel: `${anchor.label} · ${result.actualLat.toFixed(3)}, ${result.actualLon.toFixed(3)}`,
        loading: false,
        error: "",
        mode: metricChartConfig(preset.id).mode,
        rows: result.series,
        overlayRows,
      };
    } catch (err) {
      forecastSeries = {
        presetId: preset.id,
        anchorKey: anchor.key,
        anchorLabel: anchor.label,
        loading: false,
        error: err?.message || String(err),
        mode: metricChartConfig(preset.id).mode,
        rows: [],
        overlayRows: [],
      };
    }
    if (!suppressRender) renderBottomPanelOnly();
  }

  async function refreshForecastDrivenViews() {
    const serviceIso = currentServiceFrameIso();
    const shouldRefreshData = serviceIso && serviceIso !== lastForecastRefreshServiceIso;
    if (shouldRefreshData && activeForecastLayer.refresh && activeForecastLayer.presetId === currentPreset()?.id) {
      try {
        await activeForecastLayer.refresh();
        lastForecastRefreshServiceIso = serviceIso;
      } catch (err) {
        console.error("[RealtimeWeather] active wind refresh failed", err);
        status = `Wind refresh failed: ${err?.message || String(err)}`;
      }
    }
    if (shouldRefreshData && picker.latlng && currentSampleConfig()) {
      await sampleCurrentPresetAt(picker.latlng, {
        suppressBottomRender: true,
        suppressForecastSeries: true,
      });
    } else {
      updateBottomPanelSelectionUi();
    }
  }

  function renderBottomPanelHtml() {
    const preset = currentPreset();
    const times = forecastTimesForPreset();
    const chartRows = forecastSeries.presetId === preset.id ? forecastSeries.rows : [];
    const overlaySourceRows = forecastSeries.presetId === preset.id ? forecastSeries.overlayRows : [];
    const chartConfig = metricChartConfig(preset.id);
    const hourlyRows = buildHourlyChartRows(chartRows, times, chartConfig.valueFromRow);
    const selectedIso = selectedForecastIsoFromState(hourlyRows.map((row) => row.iso));
    const hourlyOverlayRows = chartConfig.overlayPresetId
      ? buildHourlyChartRows(overlaySourceRows, times, chartConfig.overlayValueFromRow)
      : [];
    const overlayLookup = new Map(hourlyOverlayRows.map((row) => [row.iso, row]));
    const maxValue = hourlyRows.length
      ? Math.max(
        ...hourlyRows.map((row) => Number(row.value) || 0),
        ...hourlyOverlayRows.map((row) => Number(row.value) || 0),
        1,
      )
      : 1;
    const barsHtml = hourlyRows.map((row) => {
      const active = row.selectIso === selectedIso && row.actual;
      const overlayRow = overlayLookup.get(row.iso) || null;
      const barHeight = Math.max(10, ((Number(row.value) || 0) / Math.max(1, maxValue)) * 132);
      const overlayHeight = overlayRow ? Math.max(barHeight, ((Number(overlayRow.value) || 0) / Math.max(1, maxValue)) * 132) : 0;
      const hoverText = chartConfig.formatReadout(row.iso, row.value, overlayRow?.value ?? null, state.timeZone);
      const fill = chartConfig.colorFromValue(row.value, chartRows.find((entry) => entry.iso === row.selectIso) || row);
      return `
        <button
          type="button"
          class="wx-forecast-bar${active ? " active" : ""}"
          data-wx-forecast-iso="${esc(row.iso)}"
          data-wx-actual="${row.actual ? "1" : "0"}"
          data-wx-hover-text="${esc(hoverText)}"
          title="${esc(hoverText)}"
          style="display:flex; flex-direction:column; align-items:center; justify-content:flex-end; width:9px; min-width:9px; height:168px; background:transparent; border:none; outline:none; padding:0; cursor:inherit;">
          <div style="position:relative; width:100%; height:132px;">
            ${overlayRow ? `<div style="position:absolute; left:1px; right:1px; bottom:0; height:${overlayHeight.toFixed(1)}px; border-radius:4px 4px 0 0; background:rgba(255,255,255,.12);"></div>` : ""}
            <div style="position:absolute; left:0; right:0; bottom:0; height:${barHeight.toFixed(1)}px; border-radius:4px 4px 0 0; background:${fill}; box-shadow:${active ? "0 0 0 2px rgba(255,255,255,.9)" : "none"};"></div>
          </div>
          <div style="width:${active ? "10px" : "0"}; height:${active ? "10px" : "0"}; border-radius:999px; background:${active ? "#f8fafc" : "transparent"}; margin-top:6px;"></div>
        </button>
      `;
    }).join("");
    const yTicks = [0, 0.25, 0.5, 0.75, 1].map((t) => ({
      value: maxValue * t,
      pct: (1 - t) * 100,
    }));
    const slotWidth = 13;
    const plotInnerWidth = Math.max(0, hourlyRows.length * slotWidth);
    const dayKeyFormatter = new Intl.DateTimeFormat("en-US", {
      timeZone: state.timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      weekday: "short",
    });
    const dayLabelFormatter = new Intl.DateTimeFormat("en-US", {
      timeZone: state.timeZone,
      weekday: "short",
      month: "short",
      day: "numeric",
    });
    const daySegments = [];
    for (let i = 0; i < hourlyRows.length; i += 1) {
      const row = hourlyRows[i];
      const dt = new Date(row.iso);
      const parts = dayKeyFormatter.formatToParts(dt);
      const key = `${parts.find((p) => p.type === "year")?.value || ""}-${parts.find((p) => p.type === "month")?.value || ""}-${parts.find((p) => p.type === "day")?.value || ""}`;
      const weekday = parts.find((p) => p.type === "weekday")?.value || "";
      const weekend = weekday === "Sat" || weekday === "Sun";
      if (!daySegments.length || daySegments[daySegments.length - 1].key !== key) {
        daySegments.push({
          key,
          start: i,
          end: i,
          label: dayLabelFormatter.format(dt),
          weekend,
        });
      } else {
        daySegments[daySegments.length - 1].end = i;
      }
    }
    const dayBandsHtml = daySegments.map((segment, index) => {
      const left = segment.start * slotWidth;
      const width = ((segment.end - segment.start) + 1) * slotWidth;
      const background = segment.weekend
        ? "rgba(96,165,250,.14)"
        : (index % 2 === 0 ? "rgba(148,163,184,.09)" : "rgba(15,23,42,.045)");
      return `<div style="position:absolute; left:${left}px; top:0; width:${width}px; height:174px; background:${background};"></div>`;
    }).join("");
    const dayLabelsHtml = daySegments.map((segment) => {
      const left = segment.start * slotWidth;
      return `<div style="position:absolute; left:${left}px; top:0; transform:translateY(-16px); font-size:10px; font-weight:600; color:${segment.weekend ? "rgba(147,197,253,.82)" : "rgba(226,232,240,.6)"}; white-space:nowrap;">${esc(segment.label)}</div>`;
    }).join("");
    const horizontalGuidesHtml = yTicks
      .filter((tick) => tick.pct > 0 && tick.pct < 100)
      .map((tick) => `<div style="position:absolute; left:0; right:0; top:${tick.pct}%; border-top:1px dashed rgba(226,232,240,.14);"></div>`)
      .join("");
    const xTicks = hourlyRows.map((row, index) => {
      const d = new Date(row.iso);
      const hour = d.getUTCHours();
      const showLabel = hour % 6 === 0 || index === 0 || index === hourlyRows.length - 1;
      const label = showLabel
        ? `${String(d.getUTCMonth() + 1).padStart(2, "0")}/${String(d.getUTCDate()).padStart(2, "0")} ${String(hour).padStart(2, "0")}Z`
        : "";
      return `
        <div style="width:9px; min-width:9px; display:flex; flex-direction:column; align-items:center;">
          <div style="width:1px; height:${showLabel ? "10px" : "6px"}; background:rgba(226,232,240,.46);"></div>
          <div style="margin-top:4px; font-size:10px; color:rgba(226,232,240,.72); white-space:nowrap;">${esc(label)}</div>
        </div>
      `;
    }).join("");
    const chartSelected = hourlyRows.find((row) => row.iso === selectedIso) || null;
    const chartSelectedOverlay = chartSelected ? overlayLookup.get(chartSelected.iso) || null : null;
    const hoverDefault = chartSelected
      ? chartConfig.formatReadout(chartSelected.iso, chartSelected.value, chartSelectedOverlay?.value ?? null, state.timeZone)
      : "Hover chart for time and value";
    const timeZoneOptions = [
      "System",
      "UTC",
      "America/Los_Angeles",
      "America/Denver",
      "America/Chicago",
      "America/New_York",
      "Pacific/Honolulu",
    ].map((tz) => {
      const value = tz === "System" ? "system" : tz;
      const selected = (tz === "System" ? state.timeZone === (Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC") : state.timeZone === tz) ? " selected" : "";
      return `<option value="${esc(value)}"${selected}>${esc(tz)}</option>`;
    }).join("");
    const playbackRateOptions = [1, 2, 3].map((rate) => {
      const selected = Number(state.playbackRate) === rate ? " selected" : "";
      return `<option value="${rate}"${selected}>${rate}x</option>`;
    }).join("");
    const pickLabel = picker.enabled ? "Stop Pick" : "Pick";
    const layerToggleLabel = state.layerVisible === false ? "Show Layer" : "Hide Layer";
    const metricButtons = metricButtonSet().map((metricId) => `
      <button
        type="button"
        class="btn${metricId === preset.id ? " primary" : ""}"
        data-wx-metric="${esc(metricId)}"
        style="justify-content:flex-start; width:92px;"
      >${esc(metricButtonLabel(metricId))}</button>
    `).join("");
    const forecastChartHtml = forecastSeries.loading
      ? `<div class="small">Loading ${esc(metricButtonLabel(preset.id).toLowerCase())} forecast series...</div>`
      : forecastSeries.error
        ? `<div class="small">Forecast series unavailable: ${esc(forecastSeries.error)}</div>`
        : chartRows.length
          ? `
            <div class="card" style="display:flex; flex-direction:column; padding:10px; border:1px solid rgba(148,163,184,.18); background:rgba(15,23,42,.18);">
              <div class="row" style="align-items:flex-start; gap:12px;">
                <div style="display:flex; flex-direction:column; gap:8px; width:92px; min-width:92px; margin-top:78px; padding-right:12px; position:relative;">
                  <div style="position:absolute; top:0; right:0; bottom:0; width:1px; background:linear-gradient(180deg, rgba(34,197,94,.08), rgba(148,163,184,.38), rgba(34,197,94,.08)); box-shadow:0 0 10px rgba(34,197,94,.12);"></div>
                  ${metricButtons}
                </div>
                <div style="flex:1; min-width:0;">
                  <div class="row" style="align-items:flex-start; gap:8px; margin-bottom:0; position:relative; left:-92px; width:calc(100% + 92px); justify-content:space-between; flex-wrap:wrap;">
                    <div id="wx-forecast-hover-readout" class="small" data-default="${esc(hoverDefault)}" style="min-height:24px; font-size:22px; line-height:1.15; font-weight:600; color:rgba(226,232,240,.96);">${esc(hoverDefault)}</div>
                    <div class="row" style="align-items:center; gap:8px; justify-content:flex-end; flex-wrap:wrap;">
                      <button id="wx-forecast-layer-toggle" class="btn ${state.layerVisible === false ? "" : "primary"}" title="${state.layerVisible === false ? "Show current weather layer on the map" : "Hide current weather layer from the map"}" aria-label="${esc(layerToggleLabel)}">${layerToggleLabel}</button>
                      <button id="wx-forecast-pick" class="btn ${picker.enabled ? "primary" : ""}" title="${picker.enabled ? "Stop map picking (Esc)" : "Start map picking"}" aria-label="${picker.enabled ? "Stop map picking" : "Start map picking"}">${pickLabel}</button>
                      <select id="wx-forecast-timezone" style="min-width:170px;">${timeZoneOptions}</select>
                      <select id="wx-forecast-rate" style="min-width:84px;">${playbackRateOptions}</select>
                      <button id="wx-forecast-prev" class="btn" title="Previous step" aria-label="Previous step"${selectedIso ? "" : " disabled"}>&lsaquo;</button>
                      <button id="wx-forecast-play" class="btn primary" title="${forecastPlayer.playing ? "Pause playback" : "Start playback"}" aria-label="${forecastPlayer.playing ? "Pause playback" : "Start playback"}">${forecastPlayer.playing ? "&#10073;&#10073;" : "&#9654;"}</button>
                      <button id="wx-forecast-next" class="btn" title="Next step" aria-label="Next step"${selectedIso ? "" : " disabled"}>&rsaquo;</button>
                    </div>
                  </div>
                  <div class="row" style="align-items:flex-end; gap:8px;">
                    <div style="width:44px; min-width:44px; height:132px; position:relative; margin-bottom:42px;">
                      ${yTicks.map((tick) => `
                        <div style="position:absolute; left:0; right:0; top:calc(${tick.pct}% - 8px); font-size:10px; color:rgba(226,232,240,.78); line-height:1; text-align:right;">
                          ${tick.value.toFixed(0)} ${esc(chartConfig.unitLabel)}
                        </div>
                      `).join("")}
                    </div>
                    <div style="flex:1; min-width:0; padding-bottom:4px;">
                      <div id="wx-forecast-scroll" style="overflow-x:auto; overflow-y:hidden; padding-bottom:6px; scrollbar-width:thin;">
                        <div style="position:relative; width:max-content; padding-left:8px; padding-top:16px;">
                          <div style="position:absolute; left:8px; top:16px; width:${plotInnerWidth}px; height:174px; overflow:hidden;">
                            ${dayBandsHtml}
                            ${horizontalGuidesHtml}
                          </div>
                          <div style="position:absolute; left:8px; top:16px; width:${plotInnerWidth}px; height:0;">
                            ${dayLabelsHtml}
                          </div>
                          <div style="position:relative; display:flex; align-items:flex-end; gap:4px; width:max-content; min-height:174px; border-left:1px solid rgba(148,163,184,.18); border-bottom:1px solid rgba(148,163,184,.18);">
                            ${barsHtml}
                          </div>
                        </div>
                        <div style="display:flex; align-items:flex-start; gap:4px; width:max-content; margin-top:6px; padding-left:8px;">
                          ${xTicks}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          `
          : `
            <div class="card" style="display:flex; flex-direction:column; padding:10px; border:1px solid rgba(148,163,184,.18); background:rgba(15,23,42,.18);">
              <div class="row" style="align-items:flex-start; gap:12px;">
                <div style="display:flex; flex-direction:column; gap:8px; width:92px; min-width:92px; margin-top:78px; padding-right:12px; position:relative;">
                  <div style="position:absolute; top:0; right:0; bottom:0; width:1px; background:linear-gradient(180deg, rgba(34,197,94,.08), rgba(148,163,184,.38), rgba(34,197,94,.08)); box-shadow:0 0 10px rgba(34,197,94,.12);"></div>
                  ${metricButtons}
                </div>
                <div style="flex:1; min-width:0;">
                  <div class="row" style="align-items:flex-start; gap:8px; margin-bottom:0; position:relative; left:-92px; width:calc(100% + 92px); justify-content:space-between; flex-wrap:wrap;">
                    <div id="wx-forecast-hover-readout" class="small" data-default="${esc(hoverDefault)}" style="min-height:24px; font-size:22px; line-height:1.15; font-weight:600; color:rgba(226,232,240,.96);">${esc(hoverDefault)}</div>
                    <div class="row" style="align-items:center; gap:8px; justify-content:flex-end; flex-wrap:wrap;">
                      <button id="wx-forecast-layer-toggle" class="btn ${state.layerVisible === false ? "" : "primary"}" title="${state.layerVisible === false ? "Show current weather layer on the map" : "Hide current weather layer from the map"}" aria-label="${esc(layerToggleLabel)}">${layerToggleLabel}</button>
                      <button id="wx-forecast-pick" class="btn ${picker.enabled ? "primary" : ""}" title="${picker.enabled ? "Stop map picking (Esc)" : "Start map picking"}" aria-label="${picker.enabled ? "Stop map picking" : "Start map picking"}">${pickLabel}</button>
                      <select id="wx-forecast-timezone" style="min-width:170px;">${timeZoneOptions}</select>
                      <select id="wx-forecast-rate" style="min-width:84px;">${playbackRateOptions}</select>
                      <button id="wx-forecast-prev" class="btn" title="Previous step" aria-label="Previous step"${selectedIso ? "" : " disabled"}>&lsaquo;</button>
                      <button id="wx-forecast-play" class="btn primary" title="${forecastPlayer.playing ? "Pause playback" : "Start playback"}" aria-label="${forecastPlayer.playing ? "Pause playback" : "Start playback"}">${forecastPlayer.playing ? "&#10073;&#10073;" : "&#9654;"}</button>
                      <button id="wx-forecast-next" class="btn" title="Next step" aria-label="Next step"${selectedIso ? "" : " disabled"}>&rsaquo;</button>
                    </div>
                  </div>
                  <div class="small">No forecast series loaded for this metric yet.</div>
                </div>
              </div>
            </div>
          `;

    return `
      <div id="wx-bottom-card" style="padding:10px 10px 0 10px;">
        <div style="padding-right:4px;">
          ${forecastChartHtml}
        </div>
      </div>
    `;
  }

  function bindBottomPanelControls() {
    const root = document.getElementById("wx-bottom-card");
    if (!root) return;
    const scroller = root.querySelector("#wx-forecast-scroll");
    if (scroller) {
      scroller.scrollLeft = forecastChartScrollLeft;
      scroller.onscroll = () => {
        forecastChartScrollLeft = scroller.scrollLeft;
      };
      scroller.onwheel = (e) => {
        const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
        if (!delta) return;
        scroller.scrollLeft += delta;
        forecastChartScrollLeft = scroller.scrollLeft;
        e.preventDefault();
      };
    }
    root.onclick = (e) => {
      const iso = e.target?.closest?.("[data-wx-forecast-iso]")?.getAttribute?.("data-wx-forecast-iso");
      if (iso) {
        setForecastSelection(iso);
        return;
      }
      const metricId = e.target?.closest?.("[data-wx-metric]")?.getAttribute?.("data-wx-metric");
      if (metricId) {
        setActiveMetric(metricId);
        return;
      }
      if (e.target?.closest?.("#wx-forecast-prev")) {
        const activeTimes = forecastStepTimes();
        const activeIso = selectedForecastIsoFromState(activeTimes);
        const idx = Math.max(0, activeTimes.findIndex((v) => v === activeIso));
        setForecastSelection(activeTimes[Math.max(0, idx - 1)] || activeIso);
        return;
      }
      if (e.target?.closest?.("#wx-forecast-next")) {
        const activeTimes = forecastStepTimes();
        const activeIso = selectedForecastIsoFromState(activeTimes);
        const idx = Math.max(0, activeTimes.findIndex((v) => v === activeIso));
        setForecastSelection(activeTimes[Math.min(activeTimes.length - 1, idx + 1)] || activeIso);
        return;
      }
      if (e.target?.closest?.("#wx-forecast-play")) {
        if (forecastPlayer.playing) stopForecastPlayback();
        else startForecastPlayback();
        return;
      }
      if (e.target?.closest?.("#wx-forecast-layer-toggle")) {
        setActiveForecastLayerVisibility(state.layerVisible === false);
        return;
      }
      if (e.target?.closest?.("#wx-forecast-pick")) {
        setPickerEnabled(!picker.enabled);
        return;
      }
    };
    root.onchange = (e) => {
      const target = e.target;
      if (target?.id === "wx-forecast-timezone") {
        const systemTz = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
        state = { ...state, timeZone: String(target.value || "system") === "system" ? systemTz : String(target.value || "UTC") };
        saveState(state);
        renderBottomPanelOnly();
        return;
      }
      if (target?.id === "wx-forecast-rate") {
        state = { ...state, playbackRate: Math.max(1, Math.min(3, Number(target.value) || 1)) };
        saveState(state);
        updateBottomPanelPlaybackUi();
      }
    };
    root.onmouseover = (e) => {
      const bar = e.target?.closest?.("[data-wx-hover-text]");
      const readout = root.querySelector("#wx-forecast-hover-readout");
      if (!bar || !readout) return;
      readout.textContent = String(bar.getAttribute("data-wx-hover-text") || "");
    };
    root.onmouseout = (e) => {
      const bar = e.target?.closest?.("[data-wx-hover-text]");
      if (!bar) return;
      const readout = root.querySelector("#wx-forecast-hover-readout");
      if (!readout) return;
      const related = e.relatedTarget;
      if (related && bar.contains?.(related)) return;
      readout.textContent = String(readout.getAttribute("data-default") || "");
    };
  }

  function updateBottomPanelSelectionUi() {
    const root = document.getElementById("wx-bottom-card");
    if (!root) return;
    const times = forecastStepTimes();
    const selectedIso = selectedForecastIsoFromState(times);
    const bars = Array.from(root.querySelectorAll(".wx-forecast-bar"));
    let selectedBar = null;
    for (const bar of bars) {
      const isActive = String(bar.getAttribute("data-wx-forecast-iso") || "") === String(selectedIso || "");
      bar.classList.toggle("active", isActive);
      const [plotWrap, marker] = Array.from(bar.children || []);
      const mainBar = plotWrap?.lastElementChild || null;
      if (mainBar) {
        mainBar.style.boxShadow = isActive ? "0 0 0 2px rgba(255,255,255,.9)" : "none";
      }
      if (marker) {
        marker.style.width = isActive ? "10px" : "0";
        marker.style.height = isActive ? "10px" : "0";
        marker.style.background = isActive ? "#f8fafc" : "transparent";
      }
      if (isActive) selectedBar = bar;
    }
    const selectedHoverText = selectedBar?.getAttribute?.("data-wx-hover-text");
    const readout = root.querySelector("#wx-forecast-hover-readout");
    if (readout && selectedHoverText) {
      readout.textContent = selectedHoverText;
      readout.setAttribute("data-default", selectedHoverText);
    }
    const prevBtn = root.querySelector("#wx-forecast-prev");
    const nextBtn = root.querySelector("#wx-forecast-next");
    if (prevBtn) prevBtn.disabled = !selectedIso;
    if (nextBtn) nextBtn.disabled = !selectedIso;
    if (selectedBar) {
      selectedBar.scrollIntoView({ block: "nearest", inline: "center", behavior: forecastPlayer.playing ? "auto" : "smooth" });
    }
  }

  function updateBottomPanelPlaybackUi() {
    const root = document.getElementById("wx-bottom-card");
    if (!root) return;
    const playBtn = root.querySelector("#wx-forecast-play");
    if (playBtn) {
      playBtn.innerHTML = forecastPlayer.playing ? "&#10073;&#10073;" : "&#9654;";
      playBtn.setAttribute("title", forecastPlayer.playing ? "Pause playback" : "Start playback");
      playBtn.setAttribute("aria-label", forecastPlayer.playing ? "Pause playback" : "Start playback");
    }
    const rateSelect = root.querySelector("#wx-forecast-rate");
    if (rateSelect) rateSelect.value = String(Math.max(1, Math.min(3, Number(state.playbackRate) || 1)));
  }

  function ensureBottomPanel() {
    if (bottomMounted) return;
    app.ui.mountBottomPanel(renderBottomPanelHtml(), {
      ownerId: "realtime-weather",
      title: "Realtime Weather",
      onShow: () => {
        bindBottomPanelControls();
        updateBottomPanelPlaybackUi();
        updateBottomPanelSelectionUi();
      },
    });
    bottomMounted = true;
  }

  function renderBottomPanelOnly() {
    if (!bottomMounted) return;
    app.ui.mountBottomPanel(renderBottomPanelHtml(), {
      ownerId: "realtime-weather",
      title: "Realtime Weather",
      onShow: () => {
        bindBottomPanelControls();
        updateBottomPanelPlaybackUi();
        updateBottomPanelSelectionUi();
      },
    });
  }

  function stopPlayback() {
    animation.playing = false;
    animation.playToken += 1;
  }

  async function transitionToFrame(idx, { instant = false, updateLayerName = true } = {}) {
    if (!animation.layerA || !animation.layerB || !animation.times.length) return false;
    if (animation.transitioning) return false;
    const map = app.map.instance;
    const nextIndex = Math.max(0, Math.min(animation.times.length - 1, Number(idx) || 0));
    const iso = String(animation.times[nextIndex] || "");
    const fromLayer = activeLayer();
    const toLayer = inactiveLayer();
    if (!toLayer || !fromLayer) return false;

    animation.transitioning = true;
    try {
      try { toLayer.setParams({ time: iso, TIME: iso }, false); } catch {}
      if (animation.visible && !map.hasLayer(toLayer)) toLayer.addTo(map);
      try { toLayer.setOpacity(0); } catch {}
      const loaded = await waitForLayerLoad(toLayer, 2200);

      if (!animation.visible) {
        // keep params in sync while hidden, no visual swap needed
      } else if (instant || !loaded) {
        try { fromLayer.setOpacity(0); } catch {}
        try { toLayer.setOpacity(animation.opacity); } catch {}
      } else {
        const fadeMs = Math.max(120, Math.min(420, Number(state.playbackMs || 800) * 0.45));
        await fadeLayers(fromLayer, toLayer, animation.opacity, fadeMs);
      }

      if (animation.visible && map.hasLayer(fromLayer)) map.removeLayer(fromLayer);
      animation.activeKey = animation.activeKey === "a" ? "b" : "a";
      animation.index = nextIndex;
      setTimelineUi();
      if (updateLayerName && animation.globalLayerId && animation.source) {
        app.services.layers.updateLayer(animation.globalLayerId, {
          name: `Weather: ${animation.source.name} @ ${fmtIso(iso)}`,
          meta: {
            source: animation.source.source,
            layerName: animation.source.layer,
            timeMode: "timeline",
            time: iso,
          },
        });
      }
      return loaded;
    } finally {
      animation.transitioning = false;
    }
  }

  async function startPlayback() {
    if (!animation.layerA || !animation.layerB || !animation.times.length) return;
    stopPlayback();
    animation.playing = true;
    const token = ++animation.playToken;
    while (animation.playing && token === animation.playToken) {
      const t0 = performance.now();
      const next = (animation.index + 1) % animation.times.length;
      await transitionToFrame(next);
      const elapsed = performance.now() - t0;
      const waitMs = Math.max(0, Number(state.playbackMs || 800) - elapsed);
      if (!animation.playing || token !== animation.playToken) break;
      await sleep(waitMs);
    }
  }

  function render() {
    if (!containerEl) return;
    containerEl.innerHTML = `
      <div class="card">
        <div class="lm-title">Realtime Weather</div>
        <div class="small" style="margin-top:6px;">Weather is controlled from the bottom workspace.</div>
        <div class="small" style="margin-top:6px; min-height:16px;">${esc(status || (picker.enabled ? "Picking enabled. Click the map or press Esc to stop." : ""))}</div>
      </div>
    `;
  }

  function addStaticPresetLayer(preset) {
    const layerId = `wx-static-${preset.id}`;
    try { app.services.layers.removeLayer(layerId); } catch {}
    const options = {
      layers: preset.layer,
      transparent: true,
      format: "image/png",
      version: "1.3.0",
      tiled: true,
      maxZoom: 22,
    };
    if (state.timeMode === "specific") {
      const iso = toWmsTime(state.timeLocal);
      if (!iso) {
        app.ui.toast("Invalid time value");
        return;
      }
      options.time = iso;
      options.TIME = iso;
    }

    app.services.layers.addLayer("realtime-weather", {
      id: layerId,
      name: `Weather: ${preset.name}`,
      group: "Weather",
      kind: "overlay",
      type: "wms",
      url: preset.url,
      options,
      opacity: Math.max(0, Math.min(1, Number(state.opacity) || 0.75)),
      visible: true,
      meta: {
        source: preset.source,
        layerName: preset.layer,
        timeMode: state.timeMode,
        time: options.time || null,
      },
      volatile: true,
    });
    app.ui.toast(`Added: ${preset.name}`);
  }

  async function addManagedScalarPresetLayer(preset, options = {}) {
    const specificIso = selectedTimeIso();
    if (state.timeMode === "specific" && !specificIso) {
      app.ui.toast("Invalid time value");
      return;
    }
    const preserveExisting = options?.preserveExisting === true;
    if (!preserveExisting) clearActiveForecastLayer();
    if (!preset.sample?.opendapUrl) {
      addStaticPresetLayer(preset);
      return;
    }
    let visible = state.layerVisible !== false;
    let opacity = Math.max(0, Math.min(1, Number(options?.initialOpacity ?? state.opacity) || 0.75));
    let overlay = null;
    let legendControl = null;
    let refreshTimer = null;
    let refreshToken = 0;
    let removed = false;
    const syncLegend = () => {
      const wantVisible = visible;
      if (wantVisible) {
        if (!legendControl) legendControl = createMetricLegendControl(preset.id);
        if (legendControl && !legendControl._map) legendControl.addTo(app.map.instance);
      } else if (legendControl?._map) {
        legendControl.remove();
      }
    };
    const refreshNow = async () => {
      if (removed) return;
      const token = ++refreshToken;
      const iso = selectedTimeIso();
      if (state.timeMode === "specific" && !iso) throw new Error("Invalid time value");
      const { sampleIso, grid } = await fetchUcarGfsScalarGridData(
        preset.sample,
        app.map.instance.getBounds(),
        iso,
        { maxCells: preset.id === "gfs-cloud" ? 240000 : 52000 },
      );
      if (removed || token !== refreshToken) return;
      const surface = renderScalarFieldOverlay(grid, preset.id);
      if (!overlay) {
        overlay = L.imageOverlay(surface.url, surface.bounds, {
          opacity: Math.max(0.2, Math.min(0.8, opacity * 0.82)),
          interactive: false,
        });
        if (visible) overlay.addTo(app.map.instance);
        syncLegend();
      } else {
        overlay.setUrl?.(surface.url);
        overlay.setBounds?.(surface.bounds);
        overlay.setOpacity?.(Math.max(0.2, Math.min(0.8, opacity * 0.82)));
      }
      app.services.layers.updateLayer(layerId, {
        name: `Weather: ${preset.name} @ ${fmtIso(sampleIso)}`,
        meta: {
          source: preset.source,
          layerName: preset.layer,
          renderMode: "scalar-grid",
          timeMode: state.timeMode,
          time: sampleIso,
        },
      });
      status = `${preset.name} loaded for ${fmtIso(sampleIso)}.`;
      render();
    };
    const queueRefresh = () => {
      if (removed) return;
      if (refreshTimer) clearTimeout(refreshTimer);
      refreshTimer = setTimeout(() => {
        refreshNow().catch((err) => {
          console.error("[RealtimeWeather] scalar metric refresh failed", err);
          status = `Metric refresh failed: ${err?.message || String(err)}`;
          render();
        });
      }, 250);
    };
    const managed = {
      setVisible(v) {
        visible = !!v;
        const has = overlay && app.map.instance.hasLayer(overlay);
        if (visible && overlay && !has) overlay.addTo(app.map.instance);
        if (!visible && has) app.map.instance.removeLayer(overlay);
        syncLegend();
      },
      setOpacity(v) {
        opacity = Math.max(0, Math.min(1, Number(v) || 0));
        overlay?.setOpacity?.(Math.max(0.2, Math.min(0.8, opacity * 0.82)));
      },
      bringToFront() {
        overlay?.bringToFront?.();
      },
      remove() {
        removed = true;
        refreshToken += 1;
        if (refreshTimer) clearTimeout(refreshTimer);
        app.map.instance.off("moveend", queueRefresh);
        app.map.instance.off("zoomend", queueRefresh);
        if (legendControl?._map) legendControl.remove();
        if (overlay && app.map.instance.hasLayer(overlay)) app.map.instance.removeLayer(overlay);
        if (activeForecastLayer.layerId === layerId) activeForecastLayer = { presetId: "", layerId: "", refresh: null };
      },
    };
    const layerId = `wx-metric-${preset.id}`;
    try { app.services.layers.removeLayer(layerId); } catch {}
    app.services.layers.addLayer("realtime-weather", {
      id: layerId,
      name: `Weather: ${preset.name}${specificIso ? ` @ ${fmtIso(specificIso)}` : ""}`,
      group: "Weather",
      kind: "overlay",
      type: "managed",
      managed,
      opacity,
      visible,
      volatile: true,
      meta: {
        source: preset.source,
        layerName: preset.layer,
        renderMode: "scalar-grid",
        timeMode: state.timeMode,
        time: specificIso || null,
      },
    });
    app.map.instance.on("moveend", queueRefresh);
    app.map.instance.on("zoomend", queueRefresh);
    activeForecastLayer = { presetId: preset.id, layerId, refresh: refreshNow };
    await refreshNow();
    return layerId;
  }

  async function activateCurrentMetricLayer(options = {}) {
    const preset = currentPreset();
    if (!preset) return;
    if (preset.vector) {
      await addWindParticleLayer(preset, options);
      return;
    }
    loading = true;
    status = `Loading ${preset.name}...`;
    render();
    try {
      await addManagedScalarPresetLayer(preset, options);
      status = `Loaded ${preset.name}.`;
    } catch (err) {
      console.error("[RealtimeWeather] metric layer load failed", err);
      status = `Metric load failed: ${err?.message || String(err)}`;
      app.ui.toast("Metric layer load failed");
    } finally {
      loading = false;
      render();
    }
  }

  async function addWindParticleLayer(preset, options = {}) {
    if (!preset?.vector) {
      app.ui.toast("Wind particles are not available for this layer");
      return;
    }
    const specificIso = selectedTimeIso();
    if (state.timeMode === "specific" && !specificIso) {
      app.ui.toast("Invalid time value");
      return;
    }

    loading = true;
    status = `Loading wind particles for ${preset.name}...`;
    render();
    try {
      await ensureVelocityPluginLoaded();
      const preserveExisting = options?.preserveExisting === true;
      if (!preserveExisting) clearActiveForecastLayer();

      let velocityLayer = null;
      let colorOverlay = null;
      let legendControl = null;
      let refreshTimer = null;
      let refreshToken = 0;
      let removed = false;
      let visible = state.layerVisible !== false;
      let opacity = Math.max(0, Math.min(1, Number(options?.initialOpacity ?? state.opacity) || 0.75));
      let currentName = `Wind: ${preset.name}`;
      let layerMeta = { legendAvailable: true, legendVisible: true };

      const updateWind = async () => {
        if (removed) return;
        const token = ++refreshToken;
        const refreshSpecificIso = selectedTimeIso();
        if (state.timeMode === "specific" && !refreshSpecificIso) {
          throw new Error("Invalid time value");
        }
        const particleOptions = getWindParticleOptions(app.map.instance);
        const { records, sampleIso, grid } = await fetchUcarGfsWindData(
          preset.vector,
          app.map.instance.getBounds(),
          refreshSpecificIso,
          { maxCells: 52000 },
        );
        if (removed || token !== refreshToken) return;
        currentName = `Wind: ${preset.name} @ ${fmtIso(sampleIso)}`;
        const colorSurface = renderWindFieldOverlay(grid);
        const particleOpacity = getWindParticleOpacity(opacity);
        const colorOpacity = getWindColorOverlayOpacity(opacity);
        if (!velocityLayer) {
          colorOverlay = L.imageOverlay(colorSurface.url, colorSurface.bounds, {
            opacity: colorOpacity,
            interactive: false,
          });
          if (visible) colorOverlay.addTo(app.map.instance);
          velocityLayer = L.velocityLayer({
            data: records,
            displayValues: false,
            opacity: particleOpacity,
            paneName: "overlayPane",
            ...particleOptions,
          });
          if (visible) velocityLayer.addTo(app.map.instance);
          colorOverlay?.bringToBack?.();
        } else {
          colorOverlay?.setUrl?.(colorSurface.url);
          colorOverlay?.setBounds?.(colorSurface.bounds);
          colorOverlay?.setOpacity?.(colorOpacity);
          velocityLayer.setData(records);
          velocityLayer.setOptions({
            opacity: particleOpacity,
            ...particleOptions,
          });
          velocityLayer?.bringToFront?.();
        }
        app.services.layers.updateLayer(layerId, {
          name: currentName,
          meta: {
            source: preset.source,
            layerName: preset.layer,
            renderMode: "wind-particles",
            timeMode: state.timeMode,
            time: sampleIso,
          },
        });
        status = `Wind particles loaded for ${fmtIso(sampleIso)}.`;
        render();
      };

      const queueRefresh = () => {
        if (removed) return;
        if (refreshTimer) clearTimeout(refreshTimer);
        refreshTimer = setTimeout(() => {
          updateWind().catch((err) => {
            console.error("[RealtimeWeather] wind particle refresh failed", err);
            status = `Wind refresh failed: ${err?.message || String(err)}`;
            render();
          });
        }, 250);
      };
      const refreshNow = async () => {
        if (removed) return;
        await updateWind();
        renderBottomPanelOnly();
      };

      const syncLegend = (meta = {}) => {
        const wantVisible = visible && meta.legendVisible === true;
        if (wantVisible) {
          if (!legendControl) legendControl = createMetricLegendControl(preset.id);
          if (!legendControl._map) legendControl.addTo(app.map.instance);
        } else if (legendControl?._map) {
          legendControl.remove();
        }
      };

      const managed = {
        setVisible(v) {
          visible = !!v;
          const hasVelocity = velocityLayer && app.map.instance.hasLayer(velocityLayer);
          const hasColor = colorOverlay && app.map.instance.hasLayer(colorOverlay);
          if (visible && velocityLayer && !hasVelocity) velocityLayer.addTo(app.map.instance);
          if (visible && colorOverlay && !hasColor) colorOverlay.addTo(app.map.instance);
          if (!visible && hasVelocity) app.map.instance.removeLayer(velocityLayer);
          if (!visible && hasColor) app.map.instance.removeLayer(colorOverlay);
          velocityLayer?.bringToFront?.();
          colorOverlay?.bringToBack?.();
          syncLegend(layerMeta);
        },
        setOpacity(v) {
          opacity = Math.max(0, Math.min(1, Number(v) || 0));
          velocityLayer?.setOptions?.({ opacity: getWindParticleOpacity(opacity) });
          colorOverlay?.setOpacity?.(getWindColorOverlayOpacity(opacity));
        },
        setMeta(meta) {
          layerMeta = { ...layerMeta, ...(meta || {}) };
          syncLegend(layerMeta);
        },
        bringToFront() {
          colorOverlay?.bringToFront?.();
          velocityLayer?.bringToFront?.();
        },
        remove() {
          removed = true;
          if (activeForecastLayer.refresh === refreshNow) activeForecastLayer = { presetId: "", layerId: "", refresh: null };
          refreshToken += 1;
          if (refreshTimer) clearTimeout(refreshTimer);
          app.map.instance.off("moveend", queueRefresh);
          app.map.instance.off("zoomend", queueRefresh);
          if (legendControl?._map) legendControl.remove();
          if (colorOverlay && app.map.instance.hasLayer(colorOverlay)) app.map.instance.removeLayer(colorOverlay);
          if (velocityLayer && app.map.instance.hasLayer(velocityLayer)) app.map.instance.removeLayer(velocityLayer);
        },
      };

      const layerId = `wx-wind-${preset.id}`;
      try { app.services.layers.removeLayer(layerId); } catch {}
      app.services.layers.addLayer("realtime-weather", {
        id: layerId,
        name: currentName,
        group: "Weather",
        kind: "overlay",
        type: "managed",
        managed,
        opacity,
        visible,
        volatile: true,
        meta: {
          source: preset.source,
          layerName: preset.layer,
          renderMode: "wind-particles",
          timeMode: state.timeMode,
          time: specificIso,
          legendAvailable: true,
          legendVisible: true,
        },
      });

      app.map.instance.on("moveend", queueRefresh);
      app.map.instance.on("zoomend", queueRefresh);
      activeForecastLayer = { presetId: preset.id, layerId, refresh: refreshNow };
      await refreshNow();
      app.ui.toast(`Wind particles ready: ${preset.name}`);
    } catch (err) {
      console.error("[RealtimeWeather] wind particle load failed", err);
      status = `Wind particles failed: ${err?.message || String(err)}`;
      app.ui.toast("Wind particle load failed");
    } finally {
      loading = false;
      render();
    }
  }

  async function addAnimatedPresetLayer(preset) {
    loading = true;
    status = `Loading time steps for ${preset.name}...`;
    render();
    try {
      let times = [];
      let usedFallback = false;
      try {
        const capUrl = `${preset.url}?service=WMS&request=GetCapabilities&version=1.3.0`;
        const res = await fetch(capUrl);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const xml = await res.text();
        times = parseLayerTimesFromCapabilities(xml, preset.layer);
      } catch (err) {
        console.warn("[RealtimeWeather] GetCapabilities fetch blocked/failed, using fallback timeline", err);
      }
      if (!times.length) {
        times = generateFallbackTimes(preset);
        usedFallback = true;
      }
      if (!times.length) throw new Error("No timeline frames available for layer");

      stopPlayback();
      if (animation.globalLayerId) {
        try { app.services.layers.removeLayer(animation.globalLayerId); } catch {}
      }
      const idx = nearestTimeIndex(times);
      const iso = String(times[idx]);

      const baseParams = {
        layers: preset.layer,
        transparent: true,
        format: "image/png",
        version: "1.3.0",
        tiled: true,
        maxZoom: 22,
      };

      const tileA = L.tileLayer.wms(preset.url, {
        ...baseParams,
        time: iso,
        TIME: iso,
      });
      const tileB = L.tileLayer.wms(preset.url, {
        ...baseParams,
        time: iso,
        TIME: iso,
      });

      const managed = {
        setVisible(v) {
          const vis = !!v;
          animation.visible = vis;
          if (vis) {
            const active = activeLayer();
            if (active && !app.map.instance.hasLayer(active)) active.addTo(app.map.instance);
            try { active?.setOpacity?.(animation.opacity); } catch {}
          } else {
            [animation.layerA, animation.layerB].forEach((ly) => {
              if (ly && app.map.instance.hasLayer(ly)) app.map.instance.removeLayer(ly);
            });
          }
        },
        setOpacity(v) {
          animation.opacity = Math.max(0, Math.min(1, Number(v) || 0));
          const active = activeLayer();
          try { active?.setOpacity?.(animation.opacity); } catch {}
        },
        bringToFront() {
          activeLayer()?.bringToFront?.();
          if (animation.transitioning) inactiveLayer()?.bringToFront?.();
        },
        remove() {
          [animation.layerA, animation.layerB].forEach((ly) => {
            if (ly && app.map.instance.hasLayer(ly)) app.map.instance.removeLayer(ly);
          });
        },
      };

      const gid = `wx-anim-${preset.id}`;
      try { app.services.layers.removeLayer(gid); } catch {}
      app.services.layers.addLayer("realtime-weather", {
        id: gid,
        name: `Weather: ${preset.name} @ ${fmtIso(iso)}`,
        group: "Weather",
        kind: "overlay",
        type: "managed",
        managed,
        opacity: Math.max(0, Math.min(1, Number(state.opacity) || 0.75)),
        visible: true,
        volatile: true,
        meta: {
          source: preset.source,
          layerName: preset.layer,
          timeMode: "timeline",
          time: iso,
          frameCount: times.length,
        },
      });

      animation = {
        globalLayerId: gid,
        layerA: tileA,
        layerB: tileB,
        activeKey: "a",
        source: preset,
        times,
        index: idx,
        playing: false,
        playToken: 0,
        transitioning: false,
        visible: true,
        opacity: Math.max(0, Math.min(1, Number(state.opacity) || 0.75)),
      };
      setTimelineUi();
      status = usedFallback
        ? `Loaded ${times.length} estimated frames (capabilities blocked).`
        : `Loaded ${times.length} frames.`;
      app.ui.toast(`Animated layer ready: ${preset.name}`);
    } catch (err) {
      console.error("[RealtimeWeather] animated load failed", err);
      status = `Failed to load timeline: ${err?.message || String(err)}`;
      app.ui.toast("Animated layer load failed");
    } finally {
      loading = false;
      render();
    }
  }

  async function sampleCurrentPresetAt(latlng, options = {}) {
    const { suppressBottomRender = false, suppressForecastSeries = false } = options || {};
    const sampleConfig = currentSampleConfig();
    if (!sampleConfig) {
      status = "Point sampling is not available for this layer yet.";
      render();
      return;
    }
    const specificIso = selectedTimeIso();
    if (state.timeMode === "specific" && !specificIso) {
      app.ui.toast("Invalid time value");
      return;
    }

    picker.loading = true;
    picker.token += 1;
    const token = picker.token;
    render();
    try {
      const sampleKey = makePointSampleCacheKey(sampleConfig, latlng.lat, latlng.lng, specificIso);
      const result = pointSampleCache.has(sampleKey)
        ? pointSampleCache.get(sampleKey)
        : await fetchUcarGfsPointSample(sampleConfig, latlng.lat, latlng.lng, specificIso);
      pointSampleCache.set(sampleKey, result);
      if (token !== picker.token) return;
      picker.sample = result;
      setPickerMarker(latlng);
      status = `Picked ${formatSampleSummary(result)}.`;
      if (!suppressForecastSeries) ensureForecastSeries({ force: true });
      if (!suppressForecastSeries) {
        prefetchPinnedMetricData(L.latLng(latlng.lat, latlng.lng));
      }
    } catch (err) {
      console.error("[RealtimeWeather] point sample failed", err);
      status = `Point sample failed: ${err?.message || String(err)}`;
      app.ui.toast("Point sample failed");
    } finally {
      if (token === picker.token) {
        picker.loading = false;
        render();
        if (suppressBottomRender) updateBottomPanelSelectionUi();
        else renderBottomPanelOnly();
      }
    }
  }

  function setPickerEnabled(next) {
    const enabled = !!next && !!currentSampleConfig();
    picker.enabled = enabled;
    state = { ...state, pickerEnabled: enabled };
    saveState(state);
    syncPickerCursor();
    render();
    renderBottomPanelOnly();
  }

  function handleMapClick(e) {
    if (!picker.enabled) return;
    sampleCurrentPresetAt(e.latlng);
  }

  function onClick(e) {
    if (e.target?.closest?.("#wx-play")) {
      if (animation.playing) stopPlayback(); else { startPlayback(); }
      render();
      renderBottomPanelOnly();
      return;
    }
    if (e.target?.closest?.("#wx-prev")) {
      stopPlayback();
      if (animation.times.length) transitionToFrame((animation.index - 1 + animation.times.length) % animation.times.length, { instant: true });
      render();
      renderBottomPanelOnly();
      return;
    }
    if (e.target?.closest?.("#wx-next")) {
      stopPlayback();
      if (animation.times.length) transitionToFrame((animation.index + 1) % animation.times.length, { instant: true });
      render();
      renderBottomPanelOnly();
    }
  }

  function onInput(e) {
    const t = e.target;
    if (!t) return;
    if (t.id === "wx-time-idx") {
      stopPlayback();
      transitionToFrame(Number(t.value) || 0, { instant: true, updateLayerName: false });
    }
    renderBottomPanelOnly();
  }

  function handleKeydown(e) {
    if (e.key !== "Escape") return;
    if (!picker.enabled) return;
    setPickerEnabled(false);
  }

  function onChange(e) {
    const t = e.target;
    if (!t) return;
    if (t.id === "wx-play-ms" && animation.playing) startPlayback();
    renderBottomPanelOnly();
  }

  function mount(el) {
    containerEl = el;
    if (picker.enabled && !currentSampleConfig()) picker.enabled = false;
    syncPickerCursor();
    ensureBottomPanel();
    ensureServiceTimeline(currentPreset());
    ensureForecastSeries();
    activateCurrentMetricLayer();
    lastForecastRefreshServiceIso = currentServiceFrameIso();
    render();
    offLayersChanged = app.events.on("layers:changed", (layers = []) => {
      if (!animation.globalLayerId) return;
      if (!Array.isArray(layers) || !layers.some((l) => l.id === animation.globalLayerId)) {
        stopPlayback();
        animation = {
          globalLayerId: null,
          layerA: null,
          layerB: null,
          activeKey: "a",
          source: null,
          times: [],
          index: 0,
          playing: false,
          playToken: 0,
          transitioning: false,
          visible: true,
          opacity: Math.max(0, Math.min(1, Number(state.opacity) || 0.75)),
        };
        render();
      }
    });
    app.map.instance.on("click", handleMapClick);
    offMapClick = () => app.map.instance.off("click", handleMapClick);
    window.addEventListener("keydown", handleKeydown);
    offKeydown = () => window.removeEventListener("keydown", handleKeydown);
    containerEl.addEventListener("click", onClick);
    containerEl.addEventListener("input", onInput);
    containerEl.addEventListener("change", onChange);
  }

  function destroy() {
    stopPlayback();
    stopForecastPlayback();
    clearActiveForecastLayer();
    if (animation.globalLayerId) {
      try { app.services.layers.removeLayer(animation.globalLayerId); } catch {}
    }
    clearPickerMarker();
    syncPickerCursor();
    if (offLayersChanged) {
      try { offLayersChanged(); } catch {}
      offLayersChanged = null;
    }
    if (offMapClick) {
      try { offMapClick(); } catch {}
      offMapClick = null;
    }
    if (offKeydown) {
      try { offKeydown(); } catch {}
      offKeydown = null;
    }
    if (bottomMounted) {
      app.ui.unmountBottomPanel("realtime-weather");
      bottomMounted = false;
    }
    if (!containerEl) return;
    containerEl.removeEventListener("click", onClick);
    containerEl.removeEventListener("input", onInput);
    containerEl.removeEventListener("change", onChange);
    containerEl = null;
  }

  return { mount, destroy };
}
